(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["route4me"] = factory();
	else
		root["route4me"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * @module route4me-node/utils
 * @protected
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = __webpack_require__(2)("route4me:utils");

var errors = __webpack_require__(1);

/**
 * ILogger interface
 *
 * @interface ILogger
 * @category Route4Me
 * @public
 */

var ILogger = function () {
	function ILogger() {
		_classCallCheck(this, ILogger);
	}

	_createClass(ILogger, [{
		key: "debug",

		/**
   * @typedef ILogger~LoggerParams
   * @property {string} [msg] Message to log
   * @property {Error}  [err] Error object, if error occured
   */

		/**
   * Debug
   * @param {ILogger~LoggerParams|Error|string} [arg]    Something to log
   */
		// eslint-disable-next-line class-methods-use-this, no-unused-vars
		value: function debug(arg) {}
		/**
   * Info
   * @param {ILogger~LoggerParams|Error|string} [arg]    Something to log
   */

	}, {
		key: "info",
		value: function info(arg) {} // eslint-disable-line class-methods-use-this, no-unused-vars
		/**
   * Warning
   * @param {ILogger~LoggerParams|Error|string} [arg]    Something to log
   */

	}, {
		key: "warn",
		value: function warn(arg) {} // eslint-disable-line class-methods-use-this, no-unused-vars
		/**
   * Error
   * @param {ILogger~LoggerParams|Error|string} [arg]    Something to log
   */

	}, {
		key: "error",
		value: function error(arg) {} // eslint-disable-line class-methods-use-this, no-unused-vars

	}]);

	return ILogger;
}();

var CustomInternalPostProcessing = function () {
	function CustomInternalPostProcessing() {
		_classCallCheck(this, CustomInternalPostProcessing);
	}

	_createClass(CustomInternalPostProcessing, null, [{
		key: "fromJsonWithStatus",

		/**
   * status
   *
   * @private
   *
   * @example
   * Sample = {
   * 	"status": true
   * }
   *
   * @param  {Object} data - Internal
   * @param  {Object} ctx  - Internal
   * @param  {Object} res  - Internal
   * @return {boolean}     - Success
   */
		value: function fromJsonWithStatus(data, ctx, res) {
			// HACK: currently, API returns 'text/plain', so
			// the response in not parsed automatically
			if ("{\"status\":true}" === res.text) {
				debug("fromJsonWithStatus: HACK for wrong content-type");
				return true;
			}

			if (!data || "boolean" !== typeof data["status"]) {
				return new errors.Route4MeValidationError("Invalid response", data);
			}

			if (true === data["status"]) {
				return true;
			}

			// TODO: parse real error
			return new errors.Route4MeApiError("Failed", res);
		}
	}]);

	return CustomInternalPostProcessing;
}();

/*
=============================
TYPECONV
=============================
 */


function isObject(obj) {
	return null !== obj && "object" === (typeof obj === "undefined" ? "undefined" : _typeof(obj));
}

function get(obj, prop, def) {
	if (undefined === obj || null === obj) {
		return def;
	}

	var val = obj[prop];
	if (undefined === val) {
		return def;
	}

	return val;
}

function mapObject(obj, map) {
	if (null === obj || undefined === obj) {
		return obj;
	}

	var res = {};

	Object.keys(map).forEach(function (tgt) {
		var src = map[tgt];
		res[src] = obj[tgt];
	});

	return res;
}

/**
 * Deep clone an object
 *
 * @protected
 *
 * @param  {any} obj - Original object
 * @return {any}     - The deep copy of an object
 */
function clone(obj) {
	return JSON.parse(JSON.stringify(obj));
}

function uniq(arr) {
	var uq = {};
	var res = [];
	arr.forEach(function (i) {
		if (!(i in uq)) {
			uq[i] = true;
			res.push(i);
		}
	});
	return res;
}

function toStringArray(arg, trim) {
	var a = arg;

	if ("number" === typeof a) {
		return ["" + a];
	}

	if ("string" === typeof a) {
		if (false !== trim) {
			a = a.trim().split(/[,\s]+/);
		} else {
			a = a.split(/,+/);
		}
	}

	if (Array.isArray(a)) {
		a = a.map(function (x) {
			return "" + x;
		});

		return a;
	}

	throw new errors.Route4MeError("Argument is not a number OR CSV-string OR string OR array");
}

function toIntArray(arg) {
	var a = arg;
	if ("number" === typeof a) {
		return [a];
	}

	if ("string" === typeof a) {
		a = a.split(/[,\s]+/);
	}

	if (Array.isArray(a)) {
		a = a.map(function (x) {
			return Number(x);
		}).filter(function (x) {
			return "number" === typeof x;
		});

		return a;
	}

	throw new errors.Route4MeError("Argument is not a number OR CSV-string OR string OR array");
}

function toOptimizationStatesSafe(states) {
	function _isInStateRange(state) {
		if (1 > state) return false;
		if (6 < state) return false;
		return true;
	}

	var arr = void 0;
	try {
		arr = toIntArray(states);
	} catch (err) {
		return err;
	}

	arr = uniq(arr.filter(_isInStateRange));

	return arr.join(",");
}

function toIsoDateString(d) {
	return d.toISOString().substring(0, 10);
}

exports.ILogger = ILogger;
exports.CustomInternalPostProcessing = CustomInternalPostProcessing;

exports.isObject = isObject;
exports.get = get;
exports.clone = clone;
exports.mapObject = mapObject;
exports.toStringArray = toStringArray;
exports.toIntArray = toIntArray;
exports.toOptimizationStatesSafe = toOptimizationStatesSafe;
exports.toIsoDateString = toIsoDateString;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base type for all error-objects of this SDK
 *
 * @category Errors
 */

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
	function ExtendableBuiltin() {
		var instance = Reflect.construct(cls, Array.from(arguments));
		Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
		return instance;
	}

	ExtendableBuiltin.prototype = Object.create(cls.prototype, {
		constructor: {
			value: cls,
			enumerable: false,
			writable: true,
			configurable: true
		}
	});

	if (Object.setPrototypeOf) {
		Object.setPrototypeOf(ExtendableBuiltin, cls);
	} else {
		ExtendableBuiltin.__proto__ = cls;
	}

	return ExtendableBuiltin;
}

var Route4MeError = function (_extendableBuiltin2) {
	_inherits(Route4MeError, _extendableBuiltin2);

	/**
  * Create Route4MeError
  * @param  {string}           msg           [description]
  * @param  {Error}            innerError    [description]
  * @return {Route4MeError}                  [description]
  * @private
  * @inner
  */
	function Route4MeError(msg, innerError) {
		_classCallCheck(this, Route4MeError);

		var _this = _possibleConstructorReturn(this, (Route4MeError.__proto__ || Object.getPrototypeOf(Route4MeError)).call(this, msg));

		_this.innerError = innerError || null;
		_this.name = "Route4MeError";

		// // TODO: use this code!!
		// Object.defineProperty(this, 'name', {
		// 	configurable: true,
		// 	enumerable : false,
		// 	value : this.constructor.name,
		// 	writable : true,
		// });
		return _this;
	}

	return Route4MeError;
}(_extendableBuiltin(Error));

/**
 * Error received from the API-server
 *
 * @category Errors
 */


var Route4MeApiError = function (_Route4MeError) {
	_inherits(Route4MeApiError, _Route4MeError);

	/**
  * Create Route4MeApiError
  * @param  {string}             msg         [description]
  * @param  {Object}             res         [description]
  * @param  {Error}              innerError  [description]
  * @return {Route4MeApiError}               [description]
  * @private
  * @inner
  */
	function Route4MeApiError(msg, res, innerError) {
		_classCallCheck(this, Route4MeApiError);

		// TODO: remove this line:
		var _this2 = _possibleConstructorReturn(this, (Route4MeApiError.__proto__ || Object.getPrototypeOf(Route4MeApiError)).call(this, msg, innerError));

		_this2.name = "Route4MeApiError";

		_this2.statusCode = res.statusCode;
		_this2.apiPath = res.request.url;
		return _this2;
	}

	return Route4MeApiError;
}(Route4MeError);

/**
 * Error occured during internal validation
 *
 * @category Errors
 */


var Route4MeValidationError = function (_Route4MeError2) {
	_inherits(Route4MeValidationError, _Route4MeError2);

	/**
  * Create Route4MeValidationError
  * @param  {string} msg         - Message
  * @param  {*}      data        - Data under consideration
  * @param  {Error}  innerError  - Error, caused this error
  * @return {Route4MeValidationError}
  * @private
  * @inner
  */
	function Route4MeValidationError(msg, data, innerError) {
		_classCallCheck(this, Route4MeValidationError);

		// TODO: remove this line:
		var _this3 = _possibleConstructorReturn(this, (Route4MeValidationError.__proto__ || Object.getPrototypeOf(Route4MeValidationError)).call(this, msg, innerError));

		_this3.name = "Route4MeValidationError";

		/**
   * Data under consideration
   * @type {*}
   */
		_this3.data = data;
		return _this3;
	}

	return Route4MeValidationError;
}(Route4MeError);

exports.Route4MeError = Route4MeError;
exports.Route4MeApiError = Route4MeApiError;
exports.Route4MeValidationError = Route4MeValidationError;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(21);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window && typeof window.process !== 'undefined' && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document && 'WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window && window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 3 */
/***/ (function(module, exports) {

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = __webpack_require__(2)("route4me");
var platform = __webpack_require__(24);

var ActivityFeed = __webpack_require__(7);
var Addresses = __webpack_require__(9);
var AddressBook = __webpack_require__(8);
var AvoidanceZones = __webpack_require__(10);
var Geocoding = __webpack_require__(11);
var Members = __webpack_require__(12);
var Notes = __webpack_require__(13);
var Optimizations = __webpack_require__(14);
var Orders = __webpack_require__(15);
var Routes = __webpack_require__(16);
var Territories = __webpack_require__(17);
var Tracking = __webpack_require__(18);
var Vehicles = __webpack_require__(19);

var packageJson = __webpack_require__(22); // eslint-disable-line import/no-dynamic-require
var utils = __webpack_require__(0);
var errors = __webpack_require__(1);
var RequestManager = __webpack_require__(6);

/**
 * Route4Me main SDK class
 *
 * The main purpose of this class: to provide an access to API-methods and to keep
 * chore and routine in the shadow as long as possible.
 *
 * With `route4me` instance you should get responses from API easy-peasy.
 *
 * Main members of the instanse of `Route4Me` class:
 *
 * * [ActivityFeed  ]{@link ActivityFeed}
 * * [Addresses     ]{@link Addresses}
 * * [AddressBook   ]{@link AddressBook}
 * * [AvoidanceZones]{@link AvoidanceZones}
 * * [Geocoding     ]{@link Geocoding}
 * * [Members       ]{@link Members}
 * * [Notes         ]{@link Notes}
 * * [Optimizations ]{@link Optimizations}
 * * [Orders        ]{@link Orders}
 * * [Routes        ]{@link Routes}
 * * [Territories   ]{@link Territories}
 * * [Tracking      ]{@link Tracking}
 * * [Vehicles      ]{@link Vehicles}
 *
 * Each member corresponds to an bunch of methods, described in API-documentation,
 * but the most methods in this SDK have unified names:
 *
 * * `create` - to create new entity
 * * `get` - to get **one** entity (usually, by ID)
 * * `list` - returns a list of **all** entities (sometimes with `limit` and `offset`)
 * * `update` - allows to edit entity
 * * `remove` - removes/deletes the entity
 * * `search` - obviously: allows to search items by a set of criteria
 *
 * For most use cases it is necessary:
 *
 * 1. Create `route4me` instance (with your API-key)
 * 2. Call the appropriate method
 * 3. Get the result (as JSON object)
 * 4. **PROFIT**
 *
 * @summary Route4Me main SDK class
 *
 * @category Route4Me
 */

var Route4Me = function () {
	/**
  * Create new API client
  *
  * @param  {string}  apiKey API KEY
  * @param  {object}  [options] Additional options for new instance
  * @param  {string}  [options.baseUrl="https://route4me.com"] Base URL for sending requests
  * @param  {ILogger} [options.logger=null]   Logger facility
  * @param  {boolean|function} [options.promise=false] Use promises instead of
  * callbacks. Usage:
  * * `false` means _no promises, use callbacks_;
  * * `true` means _use global `Promise`_ as promises' constructor;
  * * `constructor (function)` forces to use explicit Promise library.
  * See also Examples section of this documentation.
  *
  * @param  {module:route4me-node~ValidationCallback} [options.validate=false]
  * Validator for input and output parameters of the API methods. Set **falsey**
  * value to skip autovalidation (in favor of manual check).
  *
  * @return {Route4Me}                  New API client
  */
	function Route4Me(apiKey, options) {
		_classCallCheck(this, Route4Me);

		var opt = {};

		// check options

		opt["baseUrl"] = utils.get(options, "baseUrl", "https://route4me.com");
		opt["logger"] = utils.get(options, "logger", new utils.ILogger());
		opt["promise"] = utils.get(options, "promise", false);
		opt["validate"] = utils.get(options, "validate", false);

		// TODO: decide, whether this param could be configured
		opt["userAgent"] = "superagent/3.3.2 (" + platform.name + " " + platform.version + "; Route4Me-" + platform.name + "/" + Route4Me.version + ") " + platform.description;

		debug("init", opt);
		debug("version", Route4Me.version);

		if (!apiKey) {
			throw new errors.Route4MeError("'apiKey' is not set");
		}

		var req = new RequestManager(apiKey, opt);

		this._logger = opt["logger"];

		/**
   * **ActivityFeed** related API calls
   * @type {ActivityFeed}
   * @since 0.1.12
   */
		this.ActivityFeed = new ActivityFeed(req);
		/**
   * **AddressBook** related API calls
   * @type {AddressBook}
   * @since 0.1.8
   */
		this.AddressBook = new AddressBook(req);
		/**
   * **Addresses** related API calls
   * @type {Addresses}
   * @since 0.1.8
   */
		this.Addresses = new Addresses(req);
		/**
   * **AvoidanceZones** related API calls
   * @type {AvoidanceZones}
   * @since 0.1.8
   */
		this.AvoidanceZones = new AvoidanceZones(req);
		/**
   * **Geocoding** related API calls
   * @type {Geocoding}
   * @since 0.1.9
   */
		this.Geocoding = new Geocoding(req);
		/*
   * **Members** related API calls
   * @type {Members}
   * @since 0.1.8
   */
		this.Members = new Members(req);
		/**
   * **Notes** related API calls
   * @type {Notes}
   * @since 0.1.9
   */
		this.Notes = new Notes(req);
		/**
   * **Optimizations** related API calls
   * @type {Optimizations}
   */
		this.Optimizations = new Optimizations(req);
		/**
   * **Orders** related API calls
   * @type {Orders}
   */
		this.Orders = new Orders(req);
		/**
   * **Routes** related API calls
   * @type {Routes}
   * @since 0.1.8
   */
		this.Routes = new Routes(req);
		/**
   * **Territories** related API calls
   * @type {Territories}
   */
		this.Territories = new Territories(req);
		/**
   * **Tracking** related API calls
   * @type {Tracking}
   */
		this.Tracking = new Tracking(req);
		/**
   * **Vehicles** related API calls
   * @type {Vehicles}
   */
		this.Vehicles = new Vehicles(req);

		this._logger.debug({ msg: "initialized", version: Route4Me.version });
	}

	/**
  * Version of this API client
  *
  * @since 0.1.3
  *
  * @return {string} Version
  * @static
  * @readonly
  */


	_createClass(Route4Me, [{
		key: "version",


		/**
   * Version of this API client
   *
   * @since 0.2.0
   *
   * @return {string} Version
   * @readonly
   */
		get: function get() {
			// eslint-disable-line  class-methods-use-this
			return packageJson.version;
		}
	}], [{
		key: "version",
		get: function get() {
			return packageJson.version;
		}
	}]);

	return Route4Me;
}();

module.exports = Route4Me;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @module route4me-node
 */

var errors = __webpack_require__(1);
var Route4Me = __webpack_require__(4);

module.exports = function route4meModule() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new (Function.prototype.bind.apply(Route4Me, [null].concat(args)))();
};

module.exports.version = Route4Me.version;

/**
 * API-response callback
 *
 * @callback RequestCallback
 * @category Route4Me
 * @param {Error}  err              - Error (if ocurred)
 * @param {Object} [res=undefined]  - Value returned by API (on success)
 */

/**
 * Validation callback, applied to each API-response
 *
 * @callback ValidationCallback
 *
 * @private
 *
 * @param {*}       obj          - Object to validate. Route4Me will pass
 * API-responses with this argument
 *
 * @param {string}  schemaName   - Name of the schema to validate against.
 * Route4Me will pass the name of appropriate schema for validation.
 *
 * @return {*|Error}             Returns:
 * * {@link Error} on validation error
 * * `obj` argument (modifications allowed)
 */

/**
 * @type {Route4Me}
 */
module.exports.Route4Me = Route4Me;
/**
 * @type {Route4MeError}
 */
module.exports.Route4MeError = errors.Route4MeError;
/**
 * @type {Route4MeApiError}
 */
module.exports.Route4MeApiError = errors.Route4MeApiError;
/**
 * @type {Route4MeValidationError}
 */
module.exports.Route4MeValidationError = errors.Route4MeValidationError;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var request = __webpack_require__(26);

var errors = __webpack_require__(1);

var ResponseHandler = function () {
	function ResponseHandler(PromiseConstructor, logger, validate, validateContext, callback) {
		_classCallCheck(this, ResponseHandler);

		var cb = "function" !== typeof callback ? function (x) {
			return x;
		} : callback;
		this._logger = logger;

		this._validate = validate;
		this._validateContext = validateContext;

		if (PromiseConstructor) {
			var self = this;
			this._p = new PromiseConstructor(function (res, rej) {
				self._res = res;
				self._rej = rej;
			});
		} else {
			this._p = undefined;
			this._res = function (res) {
				return cb(null, res);
			};
			this._rej = function (err) {
				return cb(err);
			};
		}
	}

	_createClass(ResponseHandler, [{
		key: "callback",
		value: function callback(err, res) {
			if (err) {
				return this._handleError(err, res);
			}
			return this._handleOk(res);
		}
	}, {
		key: "fail",
		value: function fail(err) {
			return this._rej(err);
		}
	}, {
		key: "getPromise",
		value: function getPromise() {
			return this._p;
		}
	}, {
		key: "_handleOk",
		value: function _handleOk(res) {
			this.logger.debug({
				src: "route4me:request-manager:ResponseHandler:_handleOk",
				msg: "response ok"
			});

			var data = this._validate(res.body, this._validateContext, res);

			if (data instanceof errors.Route4MeError) {
				// TODO: include url and method to the log message
				this._logger.warn({ "msg": "response validation error", "err": data });
				return this.fail(data);
			} else if (data instanceof Error) {
				// TODO: include url and method to the log message
				this._logger.error({ "msg": "Unhandled error during validation", "err": data, "fatal": true });
				return this.fail(data);
			}

			// TODO: include url and method to the log message
			this._logger.info({ "msg": "response ok" });
			return this._res(data);
		}
	}, {
		key: "_handleError",
		value: function _handleError(err, res) {
			this.logger.debug({
				src: "route4me:request-manager:ResponseHandler:_handleError",
				msg: "response error"
			});
			var e = new errors.Route4MeApiError(err.message, res, err);

			// TODO: include url and method to the log message
			this._logger.warn({ "msg": "response error", "err": e });
			return this.fail(e);
		}
	}, {
		key: "logger",
		get: function get() {
			return this._logger;
		}
	}]);

	return ResponseHandler;
}();

/**
 * Request manager, provides
 * * simple API for sending HTTP requests
 * * a way to handle HTTP responses
 *
 * @since 0.1.0
 *
 * @protected
 */


var RequestManager = function () {
	/**
  * Creates new RequestManager. All parameters are inherited from {Route4Me}
  *
  * @param {object} apiKey  - see {Route4Me}
  * @param {object} options - see {Route4Me}
  * @return {RequestManager} - New Request Manager
  */
	function RequestManager(apiKey, options) {
		_classCallCheck(this, RequestManager);

		var opt = options;

		this._apiKey = apiKey;
		this._baseUrl = opt["baseUrl"];
		this._userAgent = opt["userAgent"];

		this._logger = opt["logger"];
		this._validate = "function" === typeof opt["validate"] ? opt["validate"] : function (ix) {
			return ix;
		};

		if (true === opt["promise"]) {
			this.logger.debug({
				src: "route4me:request-manager:RequestManager",
				msg: "promises: global Promise"
			});
			this._promiseConstructor = Promise;
		} else if ("function" === typeof opt["promise"]) {
			this.logger.debug({
				src: "route4me:request-manager:RequestManager",
				msg: "promises: explicitly defined promise-lib"
			});
			this._promiseConstructor = opt["promise"];
		} else {
			this.logger.debug({
				src: "route4me:request-manager:RequestManager",
				msg: "promises: off"
			});
			this._promiseConstructor = null;
		}
	}

	_createClass(RequestManager, [{
		key: "_makeRequest",


		/**
   * Wrapper around {@link external:superagent} with all options applied.
   *
   * @todo TODO: rename this method!!!
   * @protected
   *
   * @param {object} options              Request options
   * @param {string} options.method       HTTP method
   * @param {string} options.path         Server path
   * @param {object} [options.qs]         Query string
   * @param {object} [options.body]       Body
   * @param {null|string|function} [options.validationContext=null]
   * * `null` cause validation disabled (TODO: test this case)
   * * `string` is threated as the name of JSON Schema
   * * `function` will be used for validation.
   * @param {module:route4me-node~RequestCallback}    [callback]
   */
		value: function _makeRequest(options, callback) {
			var qs = options.qs || {}; /* query string */
			var body = options.body || null;
			var form = options.form || null;
			var timeouts = {
				response: 5000, // Wait 5 seconds for the server to start sending,
				deadline: 10000 };
			var method = options.method.toLowerCase();
			if ("delete" === method) {
				method = "del";
			}

			var apiUrl = void 0;
			if (options.url) {
				this.logger.debug({
					src: "route4me:request-manager:RequestManager:_makeRequest",
					msg: "WARNING: _makeRequest called with FULL url, but MUST be called only for partial path",
					url: options.url
				});

				apiUrl = options.url;
			} else {
				apiUrl = "" + this._baseUrl + options.path;
			}

			qs["api_key"] = this._apiKey;

			if (undefined === options.validationContext) {
				// this is just a protective wall
				throw new errors.Route4MeError("validationContext should not be undefined");
			}

			var v = this._validate;
			var c = options.validationContext || null;
			if ("function" === typeof c) {
				v = c;
				c = null;
			}

			this.logger.info({
				src: "route4me:request-manager:RequestManager:_makeRequest",
				msg: "sending request",
				method: method,
				url: apiUrl,
				queryString: qs
			});

			var resHandler = new ResponseHandler(this._promiseConstructor, this._logger, v, c, callback);

			// debug only!
			// qs["oldUrl"] = apiUrl
			// apiUrl = "https://httpbin.org/get"

			var req = request[method](apiUrl).set("Route4Me-User-Agent", this._userAgent).timeout(timeouts).redirects(1000) // unlimited number of redirects
			.accept("application/json").query(qs);

			if (form) {
				req.type("multipart/form-data").field(form);
			} else {
				req.type("application/json").send(body);
			}

			req.end(function (err, res) {
				return resHandler.callback(err, res);
			});

			return resHandler.getPromise();
		}

		/**
   * Early cancel request
   *
   * @todo TODO: rename this method!!!
   * @todo TODO: write documentation
   *
   * @param {Error}   error    The reason the request was cancelled.
   * @param {module:route4me-node~RequestCallback}    [callback]
   */

	}, {
		key: "_makeError",
		value: function _makeError(error, callback) {
			var resHandler = new ResponseHandler(this._promiseConstructor, this._logger, this._validate, null, callback);

			setTimeout(function () {
				resHandler.fail(error);
			}, 0);

			return resHandler.getPromise();
		}
	}, {
		key: "logger",
		get: function get() {
			return this._logger;
		}
	}]);

	return RequestManager;
}();

module.exports = RequestManager;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = __webpack_require__(0);
// const errors          = require("./../errors")

// ===================================

/**
 * Enum for all known **activity type**.
 * @readonly
 * @enum {string}
 * @alias ActivityTypeEnum
 * @category Route4Me
 */
var activityTypeEnum = {
	/* eslint-disable key-spacing */
	AreaAdded: "area-added",
	AreaRemoved: "area-removed",
	AreaUpdated: "area-updated",

	GeofenceEntered: "geofence-entered",
	GeofenceLeft: "geofence-left",

	RouteDelete: "route-delete",
	RouteOptimized: "route-optimized",
	RouteOwnerChanged: "route-owner-changed",

	DeleteDestination: "delete-destination",
	DestinationOutSequence: "destination-out-sequence",
	InsertDestination: "insert-destination",
	MarkDestinationDeparted: "mark-destination-departed",
	MarkDestinationVisited: "mark-destination-visited",
	MoveDestination: "move-destination",
	UpdateDestinations: "update-destinations",

	/**
  * Get driver arrived early activities
  *
  * {@link https://route4me.io/docs/#driver-arrived-early}
  *
  * @type {string}
  */
	DriverArrivedEarly: "driver-arrived-early",
	DriverArrivedLate: "driver-arrived-late",
	DriverArrivedOnTime: "driver-arrived-on-time",

	MemberCreated: "member-created",
	MemberDeleted: "member-deleted",
	MemberModified: "member-modified",

	NoteInsert: "note-insert",

	UserMessage: "user_message"
};

var _aliases = {};
Object.keys(activityTypeEnum).forEach(function (key) {
	var v = activityTypeEnum[key];
	_aliases[key] = v;
	_aliases[v] = v;
});

var aliasedActivityTypeEnum = Object.freeze(_aliases);

/**
 * ActivityFeed facility
 *
 * @category ActivityFeed
 */

var ActivityFeed = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#activity-feed}
  * @since 0.1.12
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {ActivityFeed}                  - ActivityFeed facility
  */
	function ActivityFeed(requestManager) {
		_classCallCheck(this, ActivityFeed);

		this.r = requestManager;
		this.__activityTypeEnum = activityTypeEnum;
	}

	/**
  * Log a Specific Message
  *
  * This example demonstrates how to permanently store a specific message
  * directly to the activity feed. For example, this can be used for one or
  * two-way chat.
  *
  * **The created activity will have `activityType === "user_message"`**
  *
  * @see {@link https://route4me.io/docs/#log-a-specific-message}
  * @since 0.1.12
  *
  * @param {Object} data          - Activity Feed item
  * @param {string} data.routeId  - Route ID
  * @param {string} data.message  - A message text for logging into the activity feed
  * @param {module:route4me-node~RequestCallback} [callback]
  */


	_createClass(ActivityFeed, [{
		key: "create",
		value: function create(data, callback) {
			var body = {};

			body["activity_type"] = "user_message";
			body["activity_message"] = data["message"];
			body["route_id"] = data["routeId"];

			return this.r._makeRequest({
				method: "POST",
				path: "/api.v4/activity_feed.php",
				body: body,
				validationContext: utils.CustomInternalPostProcessing.fromJsonWithStatus
			}, callback);
		}

		/**
   * Enumerable of all known activity type
   * @todo TODO: move to PACKAGE level (to make it easier for usage) see {@link https://github.com/route4me/route4me-nodejs-sdk/issues/40}
   */

	}, {
		key: "list",


		/**
   * Log a Specific Message
   *
   * This example demonstrates how to permanently store a specific message
   * directly to the activity feed. For example, this can be used for one or
   * two-way chat.
   *
   * @see {@link https://route4me.io/docs/#log-a-specific-message}
   * @since 0.1.12
   *
   * @todo TODO: convert options to optional
   *
   * @param {string|Object}   criteria - Criteria for event filter. Depending on type will be
   * considered as:
   * * `string` - criteria is a string representation of [Activity type]{@link ActivityTypeEnum}
   * * `Object` - criteria is a set of filters, see below
   *
   * @param {string}  [criteria.activityType] - [Activity type]{@link ActivityTypeEnum}
   * @param {string}  [criteria.routeId]      - Route ID
   *
   * @param {Object}  [options]          - Options for activity search
   * @param {number}  [options.limit]   - List limit
   * @param {number}  [options.offset]  - List offset
   * @param {boolean} [options.includeTeamActivities=false] - Indicate, whether team
   * activities should be included
   * @param {module:route4me-node~RequestCallback<jsonschema:ActivityFeed.ActivityFeedResult>}
   * [callback]
   */
		value: function list(criteria, options, callback) {
			var qs = {};

			var cri = criteria;
			var opt = options;
			var cb = callback;

			// ARITY
			if ("undefined" === typeof cb && "function" === typeof opt) {
				// there are two params, and the second is CALLBACK
				cb = opt;
				opt = undefined;
			}

			// CRITERIA
			if ("string" === typeof cri) {
				cri = {
					"activityType": cri
				};
			}

			if (!utils.isObject(cri)) {
				cri = {};
			}

			if ("activityType" in cri && cri["activityType"] in aliasedActivityTypeEnum) {
				qs["activity_type"] = aliasedActivityTypeEnum[cri["activityType"]];
			} else {
				this.r.logger.debug({
					src: "route4me:activity-feed:list",
					msg: "ignore 'activity_type' filter"
				});
			}

			if ("routeId" in cri) {
				qs["route_id"] = cri["routeId"];
			}

			// OPTIONS

			if (!utils.isObject(opt)) {
				opt = {};
			}

			if ("offset" in opt) {
				qs["offset"] = opt["offset"];
			}

			if ("limit" in opt) {
				qs["limit"] = opt["limit"];
			}

			if (opt["includeTeamActivities"]) {
				qs["team"] = "true";
			}

			return this.r._makeRequest({
				method: "GET",
				path: "/api/get_activities.php",
				qs: qs,
				validationContext: "ActivityFeed.ActivityFeedResult"
			}, cb);
		}
	}, {
		key: "ActivityTypeEnum",
		get: function get() {
			return this.__activityTypeEnum;
		}
	}]);

	return ActivityFeed;
}();

module.exports = ActivityFeed;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = __webpack_require__(0);

/**
 * AddressBook facility
 *
 * @category AddressBook
 */

var AddressBook = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#address-book}
  * @since 0.1.8
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {AddressBook}                   - AddressBook facility
  */
	function AddressBook(requestManager) {
		_classCallCheck(this, AddressBook);

		this.r = requestManager;
	}

	/**
  * Create a new AddressBook.
  *
  * @see {@link https://route4me.io/docs/#create-a-location}
  * @since 0.1.8
  *
  * @param {jsonschema:AddressBook.AddressBook}  data       - Valid AddressBook data.
  * @param {module:route4me-node~RequestCallback<jsonschema:AddressBook.AddressBook>}
  *        [callback]
  */


	_createClass(AddressBook, [{
		key: "create",
		value: function create(data, callback) {
			return this.r._makeRequest({
				method: "POST",
				path: "/api.v4/address_book.php",
				body: data,
				validationContext: "AddressBook.AddressBook"
			}, callback);
		}

		/**
   * GET locations from an address book by a specified list of locations IDs.
   *
   * @see {@link https://route4me.io/docs/#get-locations-by-ids}
   * @since 0.1.8
   *
   * @todo TODO: Parse response
   * @todo TODO: Remove this method in favor of `list` {@link https://github.com/route4me/route4me-nodejs-sdk/issues/41}
   *
   * @param {number|string|Array<number>|Array<string>} ids - Address IDs (as number,
   * string, CSV-separated string, or an array of numbers, or an array of strings).
   * @param {module:route4me-node~RequestCallback<jsonschema:AddressBook.AddressBookSearchResult>}
   * [callback]
   */

	}, {
		key: "getMany",
		value: function getMany(ids, callback) {
			var _ids = utils.toIntArray(ids);

			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/address_book.php",
				qs: {
					"address_id": _ids
				},
				validationContext: "AddressBook.AddressBookSearchResult"
			}, callback);
		}

		/**
   * GET all locations from a user’s address book.
   *
   * @see {@link https://route4me.io/docs/#get-locations}
   * @since 0.1.8
   *
   * @todo TODO: Parse response
   * @todo TODO: Describe ALL options (in one place, list+search)
   * @todo TODO: convert options to optional
   *
   * @param {Object} options - List-parameters
   * @param {module:route4me-node~RequestCallback<jsonschema:AddressBook.AddressBookSearchResult>}
   * [callback]
   */

	}, {
		key: "list",
		value: function list(options, callback) {
			return this.search(undefined, options, callback);
		}

		/**
   * Search an address book location by containing specified text in any
   * field/defined fields.
   *
   * @see {@link https://route4me.io/docs/#get-a-location}
   * @see {@link https://route4me.io/docs/#location-search}
   * @since 0.1.8
   *
   * @todo TODO: convert options to optional
   * @todo TODO: Parse response
   * @todo TODO: Describe ALL options (in one place, list+search)
   * @todo TODO: Handle the diffrerent format of the output (when fields are set,
   * see https://github.com/route4me/route4me-nodejs-sdk/issues/38)
   *
   * @param {string} query            - Searched text
   * @param {Object} options          - List-parameters
   * @param {number} [options.limit]  - List limit
   * @param {number} [options.offset] - List offset
   * @param {module:route4me-node~RequestCallback<jsonschema:AddressBook.AddressBookSearchResult>}
   * [callback]
   */

	}, {
		key: "search",
		value: function search(query, options, callback) {
			var qs = {};
			if (null !== query && query !== undefined) {
				qs["query"] = query;
			}
			// "query": "dan",
			// "offset": "100",
			// "limit": "15",
			// "fields": "first_name,address_email",
			// "routed": "routed"

			if ("offset" in options) {
				qs["offset"] = options.offset;
			}

			if ("limit" in options) {
				qs["limit"] = options.limit;
			}

			if ("fields" in options) {
				qs["fields"] = options.fields;
			}

			if ("routed" in options && "boolean" === typeof options.routed) {
				qs["display"] = options.routed ? "routed" : "unrouted";
			}

			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/address_book.php",
				qs: qs,
				validationContext: "AddressBook.AddressBookSearchResult"
			}, callback);
		}

		/**
   * UPDATE existing address book location parameters.
   *
   * @see {@link https://route4me.io/docs/#update-a-location}
   * @since 0.1.8
   *
   * @param {string}  id       - AddressBook item ID
   * @param {jsonschema:AddressBook.AddressBook}  data  - Valid AddressBook data.
   * @param {module:route4me-node~RequestCallback<jsonschema:AddressBook.AddressBook>}
   *        [callback]
   */

	}, {
		key: "update",
		value: function update(id, data, callback) {
			var d = utils.clone(data);
			d["address_id"] = id;

			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/address_book.php",
				body: d,
				validationContext: "AddressBook.AddressBook"
			}, callback);
		}

		/**
   * REMOVE locations from an address book.
   *
   * @see {@link https://route4me.io/docs/#remove-locations}
   * @since 0.1.8
   *
   * @todo TODO: There is no schema for the response
   * @example
   * SampleResponse = {"status":true}
   *
   * @todo TODO: parse the response
   *
   * @param {number|string|Array<number>|Array<string>}  ids - locations IDs,
   * CSV-string OR one ID as string OR one ID as number OR array of strings/numbers
   * @param {module:route4me-node~RequestCallback<boolean>}
   *     [callback]
   */

	}, {
		key: "remove",
		value: function remove(ids, callback) {
			var pureIds = utils.toStringArray(ids);

			return this.r._makeRequest({
				method: "DELETE",
				path: "/api.v4/address_book.php",
				body: {
					"address_ids": pureIds
				},
				validationContext: "AddressBook.RemoveSchema"
			}, callback);
		}
	}]);

	return AddressBook;
}();

module.exports = AddressBook;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var errors = __webpack_require__(1);

function _markVisitedValidate(data) {
	if (data && true === data.status) {
		return true;
	}
	return new errors.Route4MeValidationError("Invalid response", data);
}

var _markDepartedValidate = _markVisitedValidate;

/**
 * Addresses facility
 *
 * @category Addresses
 */

var Addresses = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#addresses}
  * @since 0.1.8
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {Addresses}                     - Addresses facility
  */
	function Addresses(requestManager) {
		_classCallCheck(this, Addresses);

		this.r = requestManager;
	}

	/**
  * Get an Address from a Route
  *
  * Get an address with specified `addressId` from a route with specified `routeId`.
  *
  * @see {@link https://route4me.io/docs/#get-an-address-from-a-route}
  * @see {@link https://route4me.io/docs/#get-notes}
  * @tag Addresses
  * @tag Notes
  * @since 0.1.9
  *
  * @param {number}  id         - Address ID
  * @param {string}  routeId    - Route ID
  * @param {Object}  [options]  - Additional options for `get`
  * @param {boolean} [options.includeNotes=false] - Aquire address' notes
  * @param {module:route4me-node~RequestCallback<jsonschema:Addresses.Address>} [callback]
  */


	_createClass(Addresses, [{
		key: "get",
		value: function get(id, routeId, options, callback) {
			var cb = callback;
			var opt = options;
			if ("undefined" === typeof cb && "function" === typeof opt) {
				cb = opt;
				opt = {};
			}

			opt = opt || {};

			var includeNotes = false;
			if (undefined !== opt.includeNotes) {
				includeNotes = !!opt.includeNotes;
			}

			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/address.php",
				qs: {
					"route_id": routeId,
					"route_destination_id": id,
					"notes": includeNotes ? "1" : "0"
				},
				validationContext: "Addresses.Address"
			}, callback);
		}

		/**
   * Update custom data of the address (as a route destination).
   *
   * @see {@link https://route4me.io/docs/#update-a-route}
   * @tag Routes
   * @tag Addresses
   * @since 0.1.8
   *
   * @param {number} id       - Address ID
   * @param {string} routeId  - Route ID
   * @param {Object<string, string>} customFields - Any string dictionary
   * @param {module:route4me-node~RequestCallback<jsonschema:Addresses.Address>} [callback]
   */

	}, {
		key: "updateCustomData",
		value: function updateCustomData(id, routeId, customFields, callback) {
			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/address.php",
				qs: {
					"route_id": routeId,
					"route_destination_id": id
				},
				body: customFields,
				validationContext: "Addresses.Address"
			}, callback);
		}

		/**
   * Mark as Detected as Departed
   *
   * The example refers to the process of marking an address as Detected as Departed.
   *
   * This method affects:
   * * ++ **`is_departed`**
   * * ++ **`timestamp_last_departed`**
   *
   * @see {@link https://route4me.io/docs/#mark-as-detected-as-departed}
   * @since 0.1.9
   *
   * @param {number} id       - Address ID
   * @param {string} routeId  - Route ID
   * @param {boolean} value   - Actual value
   * @param {module:route4me-node~RequestCallback<Addresses.Address>} [callback]
   */

	}, {
		key: "markDetectedDeparted",
		value: function markDetectedDeparted(id, routeId, value, callback) {
			var qs = {
				"route_destination_id": id,
				"route_id": routeId
			};

			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/address.php",
				qs: qs,
				body: {
					"is_departed": true === value
				},
				validationContext: "Addresses.Address"
			}, callback);
		}

		/**
   * Mark as Detected as Visited
   *
   * The example refers to the process of marking an address as Detected as Visited.
   *
   * This method affects:
   * * ++ **`is_visited`**
   * * ++ **`timestamp_last_visited`**
   *
   * @see {@link https://route4me.io/docs/#mark-as-detected-as-visited}
   * @since 0.1.9
   *
   * @param {number} id       - Address ID
   * @param {string} routeId  - Route ID
   * @param {boolean} value   - Actual value
   * @param {module:route4me-node~RequestCallback<Addresses.Address>} [callback]
   */

	}, {
		key: "markDetectedVisited",
		value: function markDetectedVisited(id, routeId, value, callback) {
			var qs = {
				"route_destination_id": id,
				"route_id": routeId
			};

			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/address.php",
				qs: qs,
				body: {
					"is_visited": true === value
				},
				validationContext: "Addresses.Address"
			}, callback);
		}

		/**
   * Mark an address of a route as visited.
   *
   * This method affects:
   * * ++ **`timestamp_last_visited`**
   * * -- `is_visited`
   *
   * @see {@link https://route4me.io/docs/#mark-as-visited}
   * @since 0.1.9
   *
   * @todo HACK: method-conflict. API suggest to use "GET", SDK uses "PUT"
   *
   * @param {number} id       - Address ID
   * @param {string} routeId  - Route ID
   * @param {number} memberId - Member ID
   * @param {boolean} value   - Actual value
   * @param {module:route4me-node~RequestCallback<bool>} [callback]
   */

	}, {
		key: "markVisited",
		value: function markVisited(id, routeId, memberId, value, callback) {
			var qs = {
				"address_id": id,
				"route_id": routeId,
				"member_id": memberId
			};

			qs["is_visited"] = value ? "1" : "0";

			return this.r._makeRequest({
				method: "PUT",
				path: "/actions/address/update_address_visited.php",
				qs: qs,
				validationContext: _markVisitedValidate
			}, callback);
		}

		/**
   * Mark an address of a route as departed.
   *
   * This method affects:
   * * ++ **`timestamp_last_departed`**
   * * -- `is_departed`
   *
   * @see {@link https://route4me.io/docs/#mark-as-departed}
   * @since 0.1.9
   *
   * @todo HACK: method-conflict. API suggest to use "GET", SDK uses "PUT"
   *
   * @param {number} id       - Address ID
   * @param {string} routeId  - Route ID
   * @param {number} memberId - Member ID
   * @param {boolean} value   - Actual value
   * @param {module:route4me-node~RequestCallback<bool>} [callback]
   */

	}, {
		key: "markDeparted",
		value: function markDeparted(id, routeId, memberId, value, callback) {
			var qs = {
				"address_id": id,
				"route_id": routeId,
				"member_id": memberId
			};

			qs["is_departed"] = value ? "1" : "0";

			return this.r._makeRequest({
				method: "PUT",
				path: "/api/route/mark_address_departed.php",
				qs: qs,
				validationContext: _markDepartedValidate
			}, callback);
		}
	}]);

	return Addresses;
}();

module.exports = Addresses;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * AvoidanceZones facility
 *
 * @category AvoidanceZones
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AvoidanceZones = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#avoidance-zones}
  * @since 0.1.8
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {AvoidanceZones}                - AvoidanceZones facility
  */
	function AvoidanceZones(requestManager) {
		_classCallCheck(this, AvoidanceZones);

		this.r = requestManager;
	}

	/**
  * Create an Avoidance Zone.
  *
  * @see {@link https://route4me.io/docs/#duplicate-a-route}
  * @since 0.1.8
  *
  * @param {jsonschema:AvoidanceZones.AvoidanceZone}  data       - Valid Avoidance Zone data.
  * @param {module:route4me-node~RequestCallback<jsonschema:AvoidanceZones.AvoidanceZone>}
  *        [callback]
  */


	_createClass(AvoidanceZones, [{
		key: "create",
		value: function create(data, callback) {
			return this.r._makeRequest({
				method: "POST",
				path: "/api.v4/avoidance.php",
				body: data,
				validationContext: "AvoidanceZones.AvoidanceZone"
			}, callback);
		}

		/**
   * GET a specified Avoidance Zone by ID.
   *
   * @see {@link https://route4me.io/docs/#get-an-avoidance-zone}
   * @since 0.1.8
   *
   * @param {string}  id       - Avoidance zone ID
   * @param {module:route4me-node~RequestCallback<jsonschema:AvoidanceZones.AvoidanceZone>}
   *        [callback]
   */

	}, {
		key: "get",
		value: function get(id, callback) {
			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/avoidance.php",
				qs: {
					"territory_id": id
				},
				validationContext: "AvoidanceZones.AvoidanceZone"
			}, callback);
		}

		/**
   * GET all of the Avoidance Zones defined by a user.
   *
   * @see {@link https://route4me.io/docs/#get-multiple-avoidance-zones}
   * @since 0.1.8
   *
   * @todo TODO: There is no schema for the response, but it is just an array of known schema
   *
   * @param {module:route4me-node~RequestCallback<jsonschema:AvoidanceZones.AvoidanceZones>}
   *        [callback]
   */

	}, {
		key: "list",
		value: function list(callback) {
			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/avoidance.php",
				validationContext: "AvoidanceZones.AvoidanceZones"
			}, callback);
		}

		/**
   * UPDATE a specified Avoidance Zone.
   *
   * @see {@link https://route4me.io/docs/#update-an-avoidance-zone}
   * @since 0.1.8
   *
   * @param {string}  id       - Avoidance zone ID
   * @param {jsonschema:AvoidanceZones.AvoidanceZone}  data       - Valid Avoidance Zone data.
   * @param {module:route4me-node~RequestCallback<jsonschema:AvoidanceZones.AvoidanceZone>}
   *        [callback]
   */

	}, {
		key: "update",
		value: function update(id, data, callback) {
			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/avoidance.php",
				qs: {
					"territory_id": id
				},
				body: data,
				validationContext: "AvoidanceZones.AvoidanceZone"
			}, callback);
		}

		/**
   * DELETE a specified Avoidance Zone.
   *
   * @see {@link https://route4me.io/docs/#remove-an-avoidance-zone}
   * @since 0.1.8
   *
   * @todo TODO: There is no schema for the response
   * @example
   * SampleResponse = {"status":true}
   *
   * @todo TODO: parse the response
   *
   * @param {string}  id       - Avoidance zone ID
   * @param {module:route4me-node~RequestCallback<jsonschema:AvoidanceZones.RemoveResponse>}
   *     [callback]
   */

	}, {
		key: "remove",
		value: function remove(id, callback) {
			return this.r._makeRequest({
				method: "DELETE",
				path: "/api.v4/avoidance.php",
				qs: {
					"territory_id": id
				},
				validationContext: "AvoidanceZones.RemoveResponse"
			}, callback);
		}
	}]);

	return AvoidanceZones;
}();

module.exports = AvoidanceZones;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Geocoding facility
 *
 * @category Geocoding
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Geocoding = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#geocoding}
  * @since 0.1.9
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {Geocoding}                     - Geocoding facility
  */
	function Geocoding(requestManager) {
		_classCallCheck(this, Geocoding);

		this.r = requestManager;
	}

	/**
  * Forward Geocode Address
  *
  * Forward geocoding is the process of converting place name information
  * into latitude and longitude values.
  *
  * @todo TODO: method-conflict. API suggest to use "POST", SDK uses "GET"
  *
  * @see {@link https://route4me.io/docs/#forward-geocode-address}
  * @since 0.1.9
  *
  * @param {string} address - Address to `geocode`
  * @param {module:route4me-node~RequestCallback<jsonschema:Geocoding.Forward>}
  * [callback]
  */


	_createClass(Geocoding, [{
		key: "forward",
		value: function forward(address, callback) {
			return this.r._makeRequest({
				method: "GET",
				path: "/api/geocoder.php",
				qs: {
					"format": "json",
					"addresses": address
				},

				validationContext: "Geocoding.Forward"
			}, callback);
		}

		/**
   * Reverse Geocode Address
   *
   * With the reverse geocoding you can retrieve an address name from a geographical location
   * point (latitude, longitude). Using this method, you can get the nearest locations
   * to a specific address name. You can also get the larger scale objects (such as street
   * addresses, places, neighbourhoods, county, state or country) which include a specified
   * address.
   *
   * @todo TODO: method-conflict. API suggest to use "POST", SDK uses "GET"
   *
   * @see {@link https://route4me.io/docs/#reverse-geocode-address}
   * @since 0.1.9
   *
   * @param {number} latitude - Latitude of the geographic location
   * @param {number} longitude - Longitude of the geographic location
   * @param {module:route4me-node~RequestCallback<jsonschema:Geocoding.Reverse>}
   * [callback]
   */

	}, {
		key: "reverse",
		value: function reverse(latitude, longitude, callback) {
			return this.r._makeRequest({
				method: "GET",
				path: "/api/geocoder.php",
				qs: {
					"format": "json",
					"addresses": latitude + "," + longitude
				},

				validationContext: "Geocoding.Reverse"
			}, callback);
		}

		/**
   * Rapid Address Search by ID
   *
   * Single address geocoding refers to the process of getting a geographic
   * address by address name sent with HTTP GET data.
   *
   * @see {@link https://route4me.io/docs/#rapid-address-search}
   * @since 0.1.9
   *
   * @deprecated This is very strange, vague API method..
   *
   * @param {number} id  - Sequential number in addresses list.
   * @param {module:route4me-node~RequestCallback<jsonschema:Geocoding.Rapid>}
   * [callback]
   */

	}, {
		key: "rapidGet",
		value: function rapidGet(id, callback) {
			// ----a
			// https://rapid.route4me.com/street_data/<PK>/

			var dryId = Number(id);
			var fullurl = "https://rapid.route4me.com/street_data/" + dryId + "/";

			return this.r._makeRequest({
				method: "GET",
				url: fullurl,
				validationContext: "Geocoding.Rapid"
			}, callback);
		}

		/**
   * Rapid Address Search
   *
   * @see {@link https://route4me.io/docs/#rapid-address-search}
   * @since 0.1.9
   *
   * @deprecated This is very strange, vague API method..
   * @todo TODO: make options optional
   *
   * @param {Object} criteria - Search criterias, such as `zipcode`, `house number` and other
   * @param {number|string} [criteria.zipCode]     - Zip code of the area
   * @param {number|string} [criteria.houseNumber] - House number
   * @param {Object} options  - Search parameters
   * @param {number} [options.offset] - Start search position
   * @param {number} [options.limit]  - Search results limitation
   * @param {module:route4me-node~RequestCallback<jsonschema:Geocoding.Rapid>}
   * [callback]
   */

	}, {
		key: "rapidSearch",
		value: function rapidSearch(criteria, options, callback) {
			// ----b
			// https://rapid.route4me.com/street_data/
			// ----c
			// https://rapid.route4me.com/street_data/<OFFSET>/<LIMIT>/

			// ----d
			// https://rapid.route4me.com/street_data/zipcode/<ZIPCODE>/
			// ----g
			// https://rapid.route4me.com/street_data/zipcode/<ZIPCODE>/<OFFSET>/<LIMIT>/

			// ----e
			// https://rapid.route4me.com/street_data/service/<ZIPCODE>/<HOUSENUMBER>/
			// ----f
			// https://rapid.route4me.com/street_data/service/<ZIPCODE>/<HOUSENUMBER>/<OFFSET>/<LIMIT>/

			var pathopts = "";
			var pathservice = "";
			var pathparams = "";

			if (options && "number" === typeof options["offset"] && "number" === typeof options["limit"]) {
				pathopts = options.offset + "/" + options.limit + "/";
			}

			if (criteria) {
				var zip = criteria["zipCode"] || criteria["zipcode"];
				var house = criteria["houseNumber"] || criteria["housenumber"];
				if (zip) {
					pathservice = "zipcode/";
					pathparams = zip + "/";
				}

				if (house) {
					pathservice = "service/";
					pathparams = zip + "/" + house + "/";
				}
			}

			var fullurl = "https://rapid.route4me.com/street_data/" + pathservice + pathparams + pathopts;

			return this.r._makeRequest({
				method: "GET",
				url: fullurl,
				validationContext: "Geocoding.Rapid"
			}, callback);
		}
	}]);

	return Geocoding;
}();

module.exports = Geocoding;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = __webpack_require__(0);
var errors = __webpack_require__(1);

// ===================================

function propertyToUpper(obj, key) {
	if (key in obj) {
		// Modify original object, it is expected behaviour
		obj[key] = obj[key].toString().toUpperCase(); // eslint-disable-line no-param-reassign
	}
}

function remapUserData(data) {
	var mapped = utils.clone(data);
	mapped.dateOfBirth = mapped.dateOfBirth.toString();

	propertyToUpper(mapped, "readonlyUser");
	propertyToUpper(mapped, "hideVisitedAddresses");
	propertyToUpper(mapped, "hideRoutedAddresses");
	propertyToUpper(mapped, "hideNonfutureRoutes");
	propertyToUpper(mapped, "showAllVehicles");
	propertyToUpper(mapped, "showAllDrivers");

	return utils.mapObject(mapped, {
		"phone": "member_phone",
		"zipcode": "member_zipcode",
		"routeCount": "route_count",
		"email": "member_email",
		"type": "member_type",
		"dateOfBirth": "date_of_birth",
		"firstName": "member_first_name",
		"password": "member_password",
		"lastName": "member_last_name",
		"readonlyUser": "READONLY_USER",
		"hideVisitedAddresses": "HIDE_VISITED_ADDRESSES",
		"hideRoutedAddresses": "HIDE_ROUTED_ADDRESSES",
		"hideNonfutureRoutes": "HIDE_NONFUTURE_ROUTES",
		"showAllVehicles": "SHOW_ALL_VEHICLES",
		"showAllDrivers": "SHOW_ALL_DRIVERS"
	});
}

function remapAccountData(data) {
	var mapped = utils.clone(data);

	var res = utils.mapObject(mapped, {
		"industry": "strIndustry",
		"firstName": "strFirstName",
		"lastName": "strLastName",
		"email": "strEmail",
		"deviceType": "device_type",
		"password": "strPassword_1"
	});

	res["strPassword_2"] = data["password"];
	res["chkTerms"] = "1";
	res["format"] = "json";

	return res;
}

// ===================================

function _removeValidate(data, ctx, res) {
	if (!data || "boolean" !== typeof data.status) {
		return new errors.Route4MeValidationError("Invalid response", data);
	}

	if (true === data.status) {
		return true;
	}

	// TODO: parse real error
	return new errors.Route4MeApiError("Failed", res);
}

function _validateSessionValidate(data, ctx, res) {
	if (!data || "boolean" !== typeof data.authenticated || "number" !== typeof data.member_id) {
		return new errors.Route4MeValidationError("Invalid response", data);
	}

	if (true !== data.authenticated) {
		return new errors.Route4MeApiError("Not authenticated", res);
	}

	return data.member_id;
}

/**
 * Members facility
 *
 * @category Members
 */

var Members = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#territories}
  * @since 0.1.8
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {Members}                       - Members facility
  */
	function Members(requestManager) {
		_classCallCheck(this, Members);

		this.r = requestManager;
	}

	/**
  * Create an User
  *
  * @see {@link https://route4me.io/docs/#create-an-user}
  * @since 0.1.9
  *
  * @todo TODO: validate INPUT parameter with **custom** schema
  *
  * @example <caption>Sample input</caption>
  * {
  * 	"firstName": "Clay",
  * 	"lastName": "Abraham",
  * 	"phone": "571-259-5939",
  * 	"zipcode": "22102",
  * 	"routeCount": null,
  * 	"email": "skrynkovskyy+newdispatcher@gmail.com",
  * 	"type": "SUB_ACCOUNT_DISPATCHER",
  * 	"dateOfBirth": 2010,
  * 	"password": "123456",
  * 	"readonlyUser": false,
  * 	"hideVisitedAddresses": false,
  * 	"hideRoutedAddresses": false,
  * 	"hideNonfutureRoutes": false,
  * 	"showAllVehicles": false,
  * 	"showAllDrivers": false,
  * }
  *
  * @param {Object}  data                       - Parameters of new user
  * @param {string}  data.hideRoutedAddresses   - user parameter
  * @param {string}  data.phone                 - user parameter
  * @param {string}  data.zipcode               - user parameter
  * @param {number}  data.routeCount            - user parameter
  * @param {string}  data.email                 - user parameter
  * @param {string}  data.type                  - user parameter
  * @param {string}  data.dateOfBirth           - user parameter
  * @param {string}  data.firstName             - user parameter
  * @param {string}  data.password              - user parameter
  * @param {string}  data.lastName              - user parameter
  * @param {boolean} data.readonlyUser          - user parameter
  * @param {boolean} data.hideVisitedAddresses  - user parameter
  * @param {boolean} data.hideRoutedAddresses   - user parameter
  * @param {boolean} data.hideNonfutureRoutes   - user parameter
  * @param {boolean} data.showAllVehicles       - user parameter
  * @param {boolean} data.showAllDrivers        - user parameter
  * @param {module:route4me-node~RequestCallback<jsonschema:Members.Member>}
  *        [callback]
  */


	_createClass(Members, [{
		key: "create",
		value: function create(data, callback) {
			var validData = remapUserData(data);

			return this.r._makeRequest({
				method: "POST",
				path: "/api.v4/user.php",
				body: validData,
				validationContext: "Members.Members"
			}, callback);
		}

		/**
   * Member’s Sub-users
   *
   * View existing sub-users in a member’s account.
   *
   * @see {@link https://route4me.io/docs/#members-sub-users}
   * @since 0.1.9
   *
   * @todo TODO: there is no schema for response
   *
   * @param {module:route4me-node~RequestCallback<jsonschema:Members.Members>}
   *        [callback]
   */

	}, {
		key: "list",
		value: function list(callback) {
			return this.r._makeRequest({
				method: "GET",
				path: "/api/member/view_users.php",
				validationContext: "Members.Members"
			}, callback);
		}

		/**
   * Get an User Details
   *
   * @see {@link https://route4me.io/docs/#get-an-user-details}
   * @since 0.1.9
   *
   * @todo TODO: reformat output
   *
   * @param {number}  id - Member ID
   * @param {module:route4me-node~RequestCallback<jsonschema:Members.Member>}
   *        [callback]
   */

	}, {
		key: "get",
		value: function get(id, callback) {
			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/user.php",
				qs: {
					"member_id": id
				},
				validationContext: "Members.Member"
			}, callback);
		}

		/**
   * Update an existing user.
   *
   * @see {@link https://route4me.io/docs/#update-an-user}
   * @since 0.1.9
   *
   * @todo TODO: validate INPUT parameter with **custom** schema
   * @todo TODO: reformat output
   *
   * @example <caption>Sample input</caption>
   * {
   * 	"firstName": "Clay",
   * 	"lastName": "Abraham",
   * 	"phone": "571-259-5939",
   * 	"zipcode": "22102",
   * 	"routeCount": null,
   * 	"email": "skrynkovskyy+newdispatcher@gmail.com",
   * 	"type": "SUB_ACCOUNT_DISPATCHER",
   * 	"dateOfBirth": 2010,
   * 	"password": "123456",
   * 	"readonlyUser": false,
   * 	"hideVisitedAddresses": false,
   * 	"hideRoutedAddresses": false,
   * 	"hideNonfutureRoutes": false,
   * 	"showAllVehicles": false,
   * 	"showAllDrivers": false,
   * }
   *
   * @param {number}  id - Member ID
   * @param {Object}  data                       - Parameters of new user
   * @param {string}  data.hideRoutedAddresses   - user parameter
   * @param {string}  data.phone                 - user parameter
   * @param {string}  data.zipcode               - user parameter
   * @param {number}  data.routeCount            - user parameter
   * @param {string}  data.email                 - user parameter
   * @param {string}  data.type                  - user parameter
   * @param {string}  data.dateOfBirth           - user parameter
   * @param {string}  data.firstName             - user parameter
   * @param {string}  data.password              - user parameter
   * @param {string}  data.lastName              - user parameter
   * @param {boolean} data.readonlyUser          - user parameter
   * @param {boolean} data.hideVisitedAddresses  - user parameter
   * @param {boolean} data.hideRoutedAddresses   - user parameter
   * @param {boolean} data.hideNonfutureRoutes   - user parameter
   * @param {boolean} data.showAllVehicles       - user parameter
   * @param {boolean} data.showAllDrivers        - user parameter
   * @param {module:route4me-node~RequestCallback<jsonschema:Members.Member>}
   *        [callback]
   */

	}, {
		key: "update",
		value: function update(id, data, callback) {
			var validData = remapUserData(data);

			validData["member_id"] = id;

			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/user.php",
				body: validData,
				validationContext: "Members.Member"
			}, callback);
		}

		/**
   * Remove existing user from a member’s account.
   *
   * @see {@link https://route4me.io/docs/#remove-an-user}
   * @since 0.1.9
   *
   * @param {number}  id - Member ID
   * @param {module:route4me-node~RequestCallback<jsonschema:Members.Member>}
   *        [callback]
   */

	}, {
		key: "remove",
		value: function remove(id, callback) {
			var data = {
				"member_id": id
			};

			return this.r._makeRequest({
				method: "DELETE",
				path: "/api.v4/user.php",
				body: data,
				validationContext: _removeValidate
			}, callback);
		}

		/**
   * Authentication of a user with an email and password.
   *
   * @see {@link https://route4me.io/docs/#authentication-aa}
   * @since 0.1.9
   *
   * @todo TODO: reformat output
   *
   * @param {string}  email    - Email of an user
   * @param {string}  password - Password
   * @param {module:route4me-node~RequestCallback<jsonschema:Members.Member>}
   *        [callback]
   */

	}, {
		key: "authenticate",
		value: function authenticate(email, password, callback) {
			return this.r._makeRequest({
				method: "POST",
				path: "/actions/authenticate.php",
				body: {
					"strEmail": email,
					"strPassword": password,
					"format": "json"
				},
				validationContext: "Members.Member"
			}, callback);
		}

		/**
   * Validate a Session
   *
   * Check if a session is valid.
   *
   * @see {@link https://route4me.io/docs/#validate-a-session}
   * @since 0.1.9
   *
   * @param {number}  id        - Member ID
   * @param {string}  sessionId - Session ID
   * @param {module:route4me-node~RequestCallback<number>}
   *        [callback]
   */

	}, {
		key: "validateSession",
		value: function validateSession(id, sessionId, callback) {
			return this.r._makeRequest({
				method: "GET",
				path: "/datafeed/session/validate_session.php",
				qs: {
					"session_guid": sessionId,
					"member_id": id,
					"frmt": "json"
				},
				validationContext: _validateSessionValidate
			}, callback);
		}

		/**
   * Registration of a new account.
   *
   * @see {@link https://route4me.io/docs/#register-an-account}
   * @since 0.1.9
   *
   * @todo TODO: reformat output
   *
   * @param {string}  data             - Account parameters
   * @param {string}  data.accountPlan - Account parameter
   * @param {string}  data.industry    - Account parameter
   * @param {string}  data.firstName   - Account parameter
   * @param {string}  data.lastName    - Account parameter
   * @param {string}  data.email       - Account parameter
   * @param {string}  data.deviceType  - Account parameter
   * @param {string}  data.password    - Account parameter
   * @param {module:route4me-node~RequestCallback<jsonschema:Members.Account>}
   *        [callback]
   */

	}, {
		key: "registerAccount",
		value: function registerAccount(data, callback) {
			var validData = remapAccountData(data);

			return this.r._makeRequest({
				method: "POST",
				path: "/actions/register_action.php",
				qs: {
					"plan": data.accountPlan
				},
				body: validData,
				validationContext: "Members.Account"
			}, callback);
		}
	}]);

	return Members;
}();

module.exports = Members;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = __webpack_require__(0);

/**
 * Notes facility
 *
 * @category Notes
 */

var Notes = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#tracking}
  * @since 0.1.9
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {Notes}                         - Notes facility
  */
	function Notes(requestManager) {
		_classCallCheck(this, Notes);

		this.r = requestManager;
	}

	/**
  * Add Route Notes
  *
  * * ADD Notes to a route.
  * * ADD Notes to a route using file uploading.
  *
  * @see {@link https://route4me.io/docs/#add-route-notes}
  * @see {@link https://route4me.io/docs/#add-a-note-file}
  * @since 0.1.9
  *
  * @todo TODO: improve documentation about file attaching
  * @todo TODO: parse response (it is the Note wrapped into an additional object)
  *
  * @param {Object}   data           - Note Data
  * @param {string}   data.routeId   - Route ID
  * @param {number}   data.addressId - Address ID
  * @param {number}   data.deviceLatitude  - Device latitude
  * @param {number}   data.deviceLongitude - Device longitude
  * @param {string}   data.deviceType      - Device type
  * @param {string}   data.note      - NOTE text
  * @param {blob}     data.file      - FILE to use as a note
  * @param {string}   data.type      - FILE/NOTE type. One of `DRIVER_IMG`,
  * `VEHICLE_IMG`, `ADDRESS_IMG`, `CSV_FILE`, `XLS_FILE`, `ANY_FILE`
  * @param {module:route4me-node~RequestCallback<jsonschema:Notes.NoteCreateResponse>}
  * [callback]
  */


	_createClass(Notes, [{
		key: "create",
		value: function create(data, callback) {
			var qs = utils.mapObject(data, {
				"routeId": "route_id",
				"addressId": "address_id",
				"deviceLatitude": "dev_lat",
				"deviceLongitude": "dev_lng",
				"deviceType": "device_type"
			});

			// ???
			var noteType = data.type || "dropoff";
			qs["strUpdateType"] = noteType;

			var body = void 0;
			if (data.note) {
				body = {
					// "strUpdateType": noteType, // ALREADY passed via QS
					"strNoteContents": data.note
				};
			} else {
				body = data.file;
			}

			return this.r._makeRequest({
				method: "POST",
				path: "/actions/addroutenotes.php",
				qs: qs,
				body: body,
				validationContext: "Notes.NoteCreateResponse"
			}, callback);
		}
	}]);

	return Notes;
}();

module.exports = Notes;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = __webpack_require__(0);

/**
 * Optimizations facility
 *
 * @category Optimizations
 */

var Optimizations = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#optimizations}
  * @since 0.1.3
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {Optimizations}                 - Optimizations facility
  */
	function Optimizations(requestManager) {
		_classCallCheck(this, Optimizations);

		this.r = requestManager;
	}

	/**
  * Create a new optimization
  *
  * @see {@link https://route4me.io/docs/#create-an-optimization}
  *
  * @param  {jsonschema:Optimizations.CreateRequest} optimization - Parameters for new optimization
  * @param  {module:route4me-node~RequestCallback<jsonschema:Optimizations.Response>}
  * [callback]
  */


	_createClass(Optimizations, [{
		key: "create",
		value: function create(optimization, callback) {
			return this.r._makeRequest({
				method: "POST",
				path: "/api.v4/optimization_problem.php",
				body: optimization,
				validationContext: "Optimizations.Response"
			}, callback);
		}

		/**
   * GET a single optimization by
   * [optimization_problem_id]{@link Optimizations#get~id} parameter.
   *
   * @see  {@link https://route4me.io/docs/#get-an-optimization}
   *
   * @param  {string} id - Optimization Problem ID
   * @param  {module:route4me-node~RequestCallback<jsonschema:Optimizations.Optimization>}
   * [callback]
   */

	}, {
		key: "get",
		value: function get(id, callback) {
			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/optimization_problem.php",
				qs: {
					"optimization_problem_id": id
				},
				validationContext: "Optimizations.Optimization"
			}, callback);
		}

		/**
   * GET all optimizations belonging to an user.
   *
   * @see {@link https://route4me.io/docs/#get-optimizations}
   *
   * @todo TODO: there is no JSON-schema for the response
   * @todo TODO: convert options to optional parameter
   *
   * @param {(number|string|Array<string>|Array<number>)} states   - List of states [1..6]
   * @param {Object} options          - List-parameters
   * @param {number} [options.limit]  - List limit
   * @param {number} [options.offset] - List offset
   * @param {module:route4me-node~RequestCallback<jsonschema:Optimizations.Optimizations>}
   * [callback]
   */

	}, {
		key: "list",
		value: function list(states, options, callback) {
			var validStates = utils.toOptimizationStatesSafe(states);
			if (validStates instanceof Error) {
				var err = validStates;
				return this.r._makeError(err, callback);
			}

			var qs = {};
			if (validStates) {
				qs["states"] = validStates;
			}

			if ("offset" in options) {
				qs["offset"] = options.offset;
			}

			if ("limit" in options) {
				qs["limit"] = options.limit;
			}

			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/optimization_problem.php",
				qs: qs,
				validationContext: "Optimizations.Optimizations"
			}, callback);
		}

		/*
   * Edit optimization
   *
   * Re-optimize existing optimizations by changing some parameters or addresses.
   *
   * @see {@link https://route4me.io/docs/#re-optimize-an-optimization}
   * @since 0.1.7
   *
   * @param {string} id - Optimization Problem ID
   * @param {jsonschema:Optimizations.CreateRequest}   data - New values for `Optimization`
   * @param {boolean} [reoptimize=false] - Determine, whether the `Optimization`
   * should be reoptimized
   *
   * @param {module:route4me-node~RequestCallback<jsonschema:Optimizations.Response>}
   * [callback]
   */

	}, {
		key: "update",
		value: function update(id, data, reoptimize, callback) {
			var cb = callback;
			var reopt = reoptimize;

			if (undefined === cb && "function" === typeof reopt) {
				cb = reopt;
				reopt = false;
			}

			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/optimization_problem.php",
				qs: {
					"optimization_problem_id": id,
					"reoptimize": reopt ? "1" : "0"
				},
				body: data,
				validationContext: "Optimizations.Response"
			}, cb);
		}

		/**
   * Remove an existing optimization belonging to an user.
   *
   * @see {@link https://route4me.io/docs/#remove-an-optimization}
   * @since 0.1.7
   *
   * @todo TODO: There is no schema for validation an output
   *
   * @example
   * const response = {
   *	"status":true,
   *	"removed":1
   * }
   *
   * @param {string}  id       - Optimization Problem ID
   * @param {module:route4me-node~RequestCallback<jsonschema:Optimizations.RemoveResponse>}
   * [callback]
   */

	}, {
		key: "remove",
		value: function remove(id, callback) {
			return this.r._makeRequest({
				method: "DELETE",
				path: "/api.v4/optimization_problem.php",
				qs: {
					"optimization_problem_id": id
				},
				validationContext: "Optimizations.RemoveResponse"
			}, callback);
		}

		/**
   * Insert an address into an optimization, resulting in the recalculation of optimal routes.
   *
   * @see {@link https://route4me.io/docs/#insert-an-address-into-an-optimization}
   * @tag Optimizations
   * @tag Addresses
   * @since 0.1.7
   *
   * @param {string}                              id                 - Optimization Problem ID
   * @param {Array<jsonschema:Addresses.Address>} addresses          - Addresses array
   * @param {boolean}                             [reoptimize=false] - Determine, whether the
   * `Optimization` should be reoptimized
   *
   * @param {module:route4me-node~RequestCallback<jsonschema:Addresses.Addresses>}
   * [callback]
   */

	}, {
		key: "linkAddress",
		value: function linkAddress(id, addresses, reoptimize, callback) {
			var cb = callback;
			var reopt = reoptimize;

			if (undefined === cb && "function" === typeof reopt) {
				cb = reopt;
				reopt = false;
			}

			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/optimization_problem.php",
				qs: {
					"optimization_problem_id": id,
					"reoptimize": reopt ? "1" : "0"
				},
				body: { "addresses": addresses },
				validationContext: "Addresses.Addresses"
			}, cb);
		}

		/**
   * Remove a destination (an address) with specified route_destination_id
   * from an optimization problem with specified optimization_problem_id.
   *
   * @see {@link https://route4me.io/docs/#remove-an-address-from-an-optimization}
   * @tag Optimizations
   * @tag Addresses
   * @since 0.1.7
   *
   * @todo TODO: There is no schema for validation an output
   *
   * @example
   * const response = {
   *	"deleted":true,
   *	"route_destination_id":1
   * }
   *
   * @param {string}  id         - Optimization Problem ID
   * @param {number}  addressId  - Address ID
   * @param {module:route4me-node~RequestCallback<jsonschema:Optimizations.UnlinkAddressResponse>}
   * [callback]
   */

	}, {
		key: "unlinkAddress",
		value: function unlinkAddress(id, addressId, callback) {
			return this.r._makeRequest({
				method: "DELETE",
				path: "/api.v4/address.php",
				qs: {
					"optimization_problem_id": id,
					"route_destination_id": addressId
				},
				validationContext: "Optimizations.UnlinkAddressResponse"
			}, callback);
		}
	}]);

	return Optimizations;
}();

module.exports = Optimizations;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = __webpack_require__(2)("route4me");

var utils = __webpack_require__(0);
var errors = __webpack_require__(1);

var CustomInternalPostProcessing = function () {
	function CustomInternalPostProcessing() {
		_classCallCheck(this, CustomInternalPostProcessing);
	}

	_createClass(CustomInternalPostProcessing, null, [{
		key: "list",
		value: function list(data, ctx, res) {
			if (!data || !utils.isObject(data)) {
				return new errors.Route4MeValidationError("Invalid response", data);
			}

			if (Array.isArray(data["results"]) && undefined !== data["total"]) {
				debug("Orders:list:pp received a response with an array");
				// the response is an array of Orders
				return data["results"];
			}

			if ("number" === typeof data["order_id"]) {
				debug("Orders:list:pp received a response with one item (it will be wrapped)");
				// the response contains only one item, we should wrap it to array
				return [data];
			}

			// TODO: parse real error
			return new errors.Route4MeApiError("Failed", res);
		}
	}]);

	return CustomInternalPostProcessing;
}();

// ===================================

/**
 * Orders facility
 *
 * @category Orders
 */


var Orders = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#orders}
  * @since 0.1.11
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {Orders}                        - Orders facility
  */
	function Orders(requestManager) {
		_classCallCheck(this, Orders);

		this.r = requestManager;
	}

	/**
  * Create an Order
  *
  * @example <caption>Sample input</caption>
  *
  * {
  * 	"address_1": "1358 E Luzerne St, Philadelphia, PA 19124, US",
  * 	"cached_lat"            : 48.335991,
  * 	"cached_lng"            : 31.18287,
  * 	"address_alias"         : "Auto test address",
  * 	"address_city"          : "Philadelphia",
  * 	"EXT_FIELD_first_name"  : "Igor",
  * 	"EXT_FIELD_last_name"   : "Progman",
  * 	"EXT_FIELD_email"       : "progman@gmail.com",
  * 	"EXT_FIELD_phone"       : "380380380380",
  * 	"EXT_FIELD_custom_data" : [
  * 		{
  * 			"order_id" : "10",
  * 			"name"     : "Bill Soul"
  * 		}
  * 	]
  * }
  *
  * @see {@link https://route4me.io/docs/#create-an-order}
  * @since 0.1.11
  *
  * @todo TODO: use custom input format (well formatted)
  *
  * @param {jsonschema:Orders.OrderInput} data          - New order
  * @param {module:route4me-node~RequestCallback<jsonschema:Orders.Order>} [callback]
  */


	_createClass(Orders, [{
		key: "create",
		value: function create(data, callback) {
			var body = data; // convert data

			return this.r._makeRequest({
				method: "POST",
				path: "/api.v4/order.php",
				body: body,
				validationContext: "Orders.Order"
			}, callback);
		}

		/**
   * Get an Order Details
   *
   * @see {@link https://route4me.io/docs/#get-an-order-details}
   * @since 0.1.11
   *
   * @param {number} id - Order ID
   * @param {module:route4me-node~RequestCallback<jsonschema:Orders.Order>} [callback]
   */

	}, {
		key: "get",
		value: function get(id, callback) {
			var pureId = Number(id);

			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/order.php",
				qs: {
					"order_id": pureId
				},
				validationContext: "Orders.Order"
			}, callback);
		}

		/**
   * Get all the orders created under the specific Route4Me account
   *
   * @see {@link https://route4me.io/docs/#get-orders-with-details}
   * @since 0.1.11
   *
   * @param {number|string|Array<number>|Array<string>} [ids] - Order IDs in one
   * of the following form:
   * * CSV-string
   * * one ID as string
   * * one ID as number
   * * array of strings
   * * array of numbers
   *
   * If you want to load all Orders:
   * * **Don't pass** this parameter
   * * **OR** pass `ids=undefined`
   * * **OR** pass `ids=false`
   *
   * @param {module:route4me-node~RequestCallback<jsonschema:Orders.Orders>} [callback]
   * [callback]
   */

	}, {
		key: "list",
		value: function list(ids, callback) {
			var pureIds = ids;
			var cb = callback;

			if (undefined === cb && "function" === typeof pureIds) {
				cb = pureIds;
				pureIds = undefined;
			}

			var qs = {};

			if (pureIds || 0 === pureIds) {
				pureIds = utils.toIntArray(pureIds);
				qs["order_id"] = pureIds;
			}

			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/order.php",
				qs: qs,
				validationContext: CustomInternalPostProcessing.list
			}, callback);
		}

		/**
   * Remove an Order
   *
   * @see {@link https://route4me.io/docs/#remove-an-order}
   * @since 0.1.11
   *
   * @param {number|string|Array<number>|Array<string>}  ids - Order ID/IDs to remove in one
   * of the following form:
   * * CSV-string
   * * one ID as string
   * * one ID as number
   * * array of strings
   * * array of numbers
   *
   * @param {module:route4me-node~RequestCallback} [callback]
   */

	}, {
		key: "remove",
		value: function remove(ids, callback) {
			var pureIds = utils.toIntArray(ids);

			var qs = {
				"redirect": 0
			};
			var body = {
				"order_ids": pureIds
			};

			return this.r._makeRequest({
				method: "DELETE",
				path: "/api.v4/order.php",
				qs: qs,
				body: body,
				validationContext: utils.CustomInternalPostProcessing.fromJsonWithStatus
			}, callback);
		}

		/**
   * Update an Order
   *
   * @see {@link https://route4me.io/docs/#update-an-order}
   * @since 0.1.11
   *
   * @param {number}                  id   - Order ID
   * @param {jsonschema:Orders.Order} data - Order data
   * @param {module:route4me-node~RequestCallback<jsonschema:Orders.Order>} [callback]
   */

	}, {
		key: "update",
		value: function update(id, data, callback) {
			var qs = {
				"redirect": 0
			};
			var body = utils.clone(data);
			body["order_id"] = Number(id);

			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/order.php",
				qs: qs,
				body: body,
				validationContext: "Orders.Order"
			}, callback);
		}

		/**
   * Search Orders
   *
   * @see {@link https://route4me.io/docs/#search-orders}
   * @since 0.1.11
   *
   * @todo TODO: Parse response
   * @todo TODO: Test timezone for this method {@link https://github.com/route4me/route4me-nodejs-sdk/issues/42}
   * @todo TODO: Handle the diffrerent format of the output (when fields are set,
   * see https://github.com/route4me/route4me-nodejs-sdk/issues/38)
   *
   * @param {string|Object} criteria            - Searched text or searching criteria
   * @param {Date}         [criteria.byAddDate]       - Date order was inserted
   * @param {Date}         [criteria.byScheduledDate] - Date order was scheduled for
   * @param {string}       [criteria.query]           - The text searched for
   *
   * @param {Object} [options]        - List-parameters
   * @param {number} [options.limit]  - List limit
   * @param {number} [options.offset] - List offset
   * @param {module:route4me-node~RequestCallback<jsonschema:Orders.Orders>} [callback]
   */

	}, {
		key: "search",
		value: function search(criteria, options, callback) {
			var qs = {
				"redirect": 0
			};
			var cri = criteria;
			var opt = options;
			var cb = callback;

			if ("string" === typeof cri) {
				cri = {
					"query": cri
				};
			}
			if (!utils.isObject(cri)) {
				cri = {};
			}

			if (undefined === cb && "function" === typeof opt) {
				cb = opt;
				opt = {};
			}
			if (!utils.isObject(opt)) {
				opt = {};
			}

			// OPTIONS

			if ("offset" in opt) {
				qs["offset"] = opt.offset;
			}

			if ("limit" in opt) {
				qs["limit"] = opt.limit;
			}

			if ("fields" in opt) {
				qs["fields"] = opt.fields;
			}

			// CRITERIA

			if ("query" in cri) {
				qs["query"] = cri["query"];
			}

			if ("byAddDate" in cri) {
				var d = cri["byAddDate"];
				qs["day_added_YYMMDD"] = utils.toIsoDateString(d);
			}

			if ("byScheduledDate" in cri) {
				var _d = cri["byScheduledDate"];
				qs["scheduled_for_YYMMDD"] = utils.toIsoDateString(_d);
			}

			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/order.php",
				qs: qs,
				validationContext: CustomInternalPostProcessing.list
			}, callback);
		}
	}]);

	return Orders;
}();

module.exports = Orders;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = __webpack_require__(2)("route4me");

var utils = __webpack_require__(0);
var errors = __webpack_require__(1);

var CustomInternalPostProcessing = function () {
	function CustomInternalPostProcessing() {
		_classCallCheck(this, CustomInternalPostProcessing);
	}

	_createClass(CustomInternalPostProcessing, null, [{
		key: "duplicate",

		/**
   * Handle `duplicate` output
   *
   * @private
   *
   * @example <caption>Expected input</caption>
   * Sample = {
   * 	"optimization_problem_id":"672998C4269918AFF461E5A691BAB8D0",
   * 	"success":true
   * }
   *
   * @param  {Object} data - Internal
   * @param  {Object} ctx  - Internal
   * @param  {Object} res  - Internal
   * @return {string}      - The ID of duplicate
   */
		value: function duplicate(data, ctx, res) {
			if (!data || "boolean" !== typeof data["success"] || "string" !== typeof data["optimization_problem_id"]) {
				return new errors.Route4MeValidationError("Invalid response", data);
			}

			if (true === data["success"]) {
				return data["optimization_problem_id"];
			}

			// TODO: parse real error
			return new errors.Route4MeApiError("Failed", res);
		}
	}, {
		key: "pullAddress",
		value: function pullAddress(data, ctx, res) {
			if (!data || "boolean" !== typeof data["success"]) {
				return new errors.Route4MeValidationError("Invalid response", data);
			}

			if (true === data["success"]) {
				return true;
			}

			// TODO: parse real error
			return new errors.Route4MeApiError("Failed", res);
		}

		/**
   * merge post-processor
   *
   * @private
   *
   * @example
   * Sample = {
   * 	"optimization_problem_id":"672998C4269918AFF461E5A691BAB8D0",
   * 	"success":true
   * }
   *
   * @param  {Object} data - Internal
   * @param  {Object} ctx  - Internal
   * @param  {Object} res  - Internal
   * @return {string}      - The ID of merged Route
   */

	}, {
		key: "merge",
		value: function merge(data, ctx, res) {
			return CustomInternalPostProcessing.duplicate(data, ctx, res);
		}

		/**
   * unlinkAddress
   *
   * @private
   *
   * @example
   * Sample = {
   * 	"deleted":true
   * }
   *
   * @param  {Object} data - Internal
   * @param  {Object} ctx  - Internal
   * @param  {Object} res  - Internal
   * @return {boolean}     - Success
   */

	}, {
		key: "unlinkAddress",
		value: function unlinkAddress(data, ctx, res) {
			if (!data || "boolean" !== typeof data.deleted) {
				return new errors.Route4MeValidationError("Invalid response", data);
			}

			if (true === data.deleted) {
				return true;
			}

			// TODO: parse real error
			return new errors.Route4MeApiError("Failed", res);
		}
	}]);

	return CustomInternalPostProcessing;
}();

// ===================================

/**
 * Routes facility
 *
 * @category Routes
 */


var Routes = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#routes}
  * @since 0.1.8
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {Routes}                        - Routes facility
  */
	function Routes(requestManager) {
		_classCallCheck(this, Routes);

		this.r = requestManager;
	}

	/**
  * Get a single route.
  *
  * @see {@link https://route4me.io/docs/#get-a-route}
  * @see {@link https://route4me.io/docs/#get-route-tracking-data}
  * @tag Routes
  * @tag Tracking
  * @since 0.1.8
  *
  * @param {string}  id       - Route ID
  * @param {Object} [options] - Options
  * @param {boolean} [options.includeTracking] - if `true` - the route tracking data
  * will be included into the response.
  * See also {@link https://route4me.io/docs/#get-route-tracking-data}
  * @param {boolean} [options.includeDirections] - if `true` - returns directions
  * @param {boolean} [options.includeRoutePath] - if `true` - include route path
  * @param {module:route4me-node~RequestCallback<jsonschema:Routes.Route>} [callback]
  */


	_createClass(Routes, [{
		key: "get",
		value: function get(id, options, callback) {
			var opt = options;
			var cb = callback;

			if (cb === undefined && "function" === typeof opt) {
				cb = opt;
				opt = null;
			}

			if (!opt) {
				opt = {};
			}

			var qs = {};
			qs["route_id"] = id;
			if (true === opt["includeTracking"]) {
				qs["device_tracking_history"] = "1";
			}

			if (true === opt["includeDirections"]) {
				qs["directions"] = "1";
			}

			if (undefined !== opt["includeRoutePath"]) {
				qs["route_path_output"] = opt.includeRoutePath ? "Points" : "None";
			}

			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/route.php",
				qs: qs,
				validationContext: "Routes.Route"
			}, cb);
		}

		/**
   * Get a limited number of the routes belonging to the user.
   *
   * @see {@link https://route4me.io/docs/#get-multiple-routes}
   * @since 0.1.8
   * @todo TODO: make options optional param
   *
   * @param {Object} options          - List-parameters
   * @param {number} [options.limit]  - List limit
   * @param {number} [options.offset] - List offset
   * @param {module:route4me-node~RequestCallback<jsonschema:Routes.Routes>} [callback]
   */

	}, {
		key: "list",
		value: function list(options, callback) {
			var qs = {};

			if ("limit" in options) {
				qs["limit"] = options.limit;
			}

			if ("offset" in options) {
				qs["offset"] = options.offset;
			}

			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/route.php",
				qs: qs,
				validationContext: "Routes.Routes"
			}, callback);
		}

		/**
   * Search the Routes for a Specified Text.
   *
   * Search for the specified text throughout all routes belonging to the user’s account.
   *
   * @see {@link https://route4me.io/docs/#search-routes}
   * @since 0.1.10
   *
   * @param {string} query          - A text to be searched for
   * @param {module:route4me-node~RequestCallback<jsonschema:Routes.Routes>} [callback]
   */

	}, {
		key: "search",
		value: function search(query, callback) {
			var qs = {
				"query": query.toString()
			};

			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/route.php",
				qs: qs,
				validationContext: "Routes.Routes"
			}, callback);
		}

		/**
   * Update a route’s specified parameters.
   *
   * @see {@link https://route4me.io/docs/#update-a-route}
   * @since 0.1.10
   *
   * @param {string}                  id    - Route ID
   * @param {jsonschema:Routes.Route} data  - New route data
   * @param {module:route4me-node~RequestCallback<jsonschema:Routes.Route>}
   * [callback]
   */

	}, {
		key: "update",
		value: function update(id, data, callback) {
			var qs = {
				"route_id": id
			};

			var body = data;

			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/route.php",
				qs: qs,
				body: body,
				validationContext: "Routes.Route"
			}, callback);
		}

		/**
   * Given multiple route ID’s, remove all routes at the same time.
   *
   * @see {@link https://route4me.io/docs/#remove-routes}
   * @since 0.1.8
   *
   * @todo TODO: There is no schema for the response
   * @example
   * SampleResponse = {
   * {
   * 	"deleted": true,
   * 	"route_id": "270CB108F227AD6E11827FC08EE4E2D7,C340E3F6AF28E20EFAE0FBE51759C338",
   * 	"route_ids": [
   * 		"270CB108F227AD6E11827FC08EE4E2D7",
   * 		"C340E3F6AF28E20EFAE0FBE51759C338"
   * 	]
   * }
   *
   * @todo TODO: parse the response
   *
   * @param {(number|string|Array<number>|Array<string>)}  ids - Route ID **or** comma-separated
   * list of route IDs **or** array of route IDs
   * @param {module:route4me-node~RequestCallback<jsonschema:Routes.RemoveResponse>}
   * [callback]
   */

	}, {
		key: "remove",
		value: function remove(ids, callback) {
			var idsPure = utils.toStringArray(ids);

			return this.r._makeRequest({
				method: "DELETE",
				path: "/api.v4/route.php",
				qs: {
					"route_id": idsPure
				},
				validationContext: "Routes.RemoveResponse"
			}, callback);
		}

		/**
   * Add Addresses to Routes
   *
   * @see {@link https://route4me.io/docs/#add-addresses-to-routes}
   * @tag Routes
   * @tag Addresses
   * @since 0.1.10
   *
   * @param {string}  id  - Route ID
   * @param {Array<jsonschema:Addresses.Address>} addresses   - Array of `Addresses`
   * @param {Object}  [options]                      - Insert options
   * @param {boolean} [options.optimalPosition=true] - If true, an address will be
   * inserted at optimal position of a route
   * @param {module:route4me-node~RequestCallback<jsonschema:Routes.Route>}
   * [callback]
   */

	}, {
		key: "linkAddress",
		value: function linkAddress(id, addresses, options, callback) {
			var opt = options;
			var cb = callback;
			if (undefined === cb && "function" === typeof opt) {
				cb = opt;
				opt = {};
			}

			if (!opt) {
				opt = {};
			}

			var optimalPosition = undefined === opt.optimalPosition ? true : !!opt.optimalPosition;

			var body = {};
			body["optimal_position"] = optimalPosition;
			body["addresses"] = addresses;

			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/route.php",
				qs: {
					"route_id": id
				},
				body: body,
				validationContext: "Routes.Route"
			}, cb);
		}

		/**
   * REMOVE an address from a route.
   *
   * @see {@link https://route4me.io/docs/#remove-addresses-from-routes}
   * @tag Routes
   * @tag Addresses
   * @since 0.1.10
   *
   * @param {string}  id         - Route ID
   * @param {number}  addressId  - Address ID
   * @param {module:route4me-node~RequestCallback} [callback]
   */

	}, {
		key: "unlinkAddress",
		value: function unlinkAddress(id, addressId, callback) {
			return this.r._makeRequest({
				method: "DELETE",
				path: "/api.v4/address.php",
				qs: {
					"route_id": id,
					"route_destination_id": addressId
				},
				validationContext: CustomInternalPostProcessing.unlinkAddress
			}, callback);
		}

		/**
   * Duplicates the route. More information - on Route4Me API-doc site (see links section).
   *
   * @see {@link https://route4me.io/docs/#duplicate-a-route}
   * @since 0.1.8
   *
   * @param {string}  id       - Route ID
   * @param {module:route4me-node~RequestCallback<string>} [callback] - callback, will be called
   * with the ID (<string>) of the new created Route
   */

	}, {
		key: "duplicate",
		value: function duplicate(id, callback) {
			return this.r._makeRequest({
				method: "POST",
				path: "/actions/duplicate_route.php",
				qs: {
					"route_id": id,
					"to": "none"
				},
				validationContext: CustomInternalPostProcessing.duplicate
			}, callback);
		}

		/**
   * Merges the list of routes. More information - on Route4Me API-doc site (see links section).
   *
   * @see {@link https://route4me.io/docs/#merge-routes}
   * @since 0.1.8
   *
   * @param {string|Array<string>}  ids       - Array of the Route IDs to be merged.
   * @param {module:route4me-node~RequestCallback<string>} [callback]
   */

	}, {
		key: "merge",
		value: function merge(ids, callback) {
			var idsPure = utils.toStringArray(ids);

			return this.r._makeRequest({
				method: "POST",
				path: "/actions/merge_routes.php",
				body: idsPure,
				validationContext: CustomInternalPostProcessing.merge
			}, callback);
		}

		/**
   * Share Routes
   *
   * Share a route via email.
   *
   * @see {@link https://route4me.io/docs/#share-routes}
   * @since 0.1.10
   *
   * @param {string} id     - Route ID
   * @param {string} email  - Recipient email
   * @param {module:route4me-node~RequestCallback} [callback]
   */

	}, {
		key: "share",
		value: function share(id, email, callback) {
			var qs = {
				"route_id": id,
				"response_format": "json"
			};

			var form = {
				"recipient_email": email
			};

			return this.r._makeRequest({
				method: "POST",
				path: "/actions/route/share_route.php",
				qs: qs,
				form: form,
				validationContext: utils.CustomInternalPostProcessing.fromJsonWithStatus
			}, callback);
		}

		/**
   * Move a Destination Into a Route
   *
   * _ID of the source route **is not required**_
   *
   * @see {@link https://route4me.io/docs/#move-a-destination-into-a-route}
   * @since 0.1.10
   *
   * @param {string} id       - Destination route ID
   * @param {number} addressId      - An address ID to be moved
   * @param {number} afterAddressId - An address ID in a destination route after
   * which the moved destination will be inserted
   * @param {module:route4me-node~RequestCallback} [callback]
   */

	}, {
		key: "pullAddress",
		value: function pullAddress(id, addressId, afterAddressId, callback) {
			var form = {
				"to_route_id": id,
				"route_destination_id": addressId,
				"after_destination_id": afterAddressId
			};

			return this.r._makeRequest({
				method: "POST",
				path: "/actions/route/move_route_destination.php",
				form: form,
				validationContext: CustomInternalPostProcessing.pullAddress
			}, callback);
		}

		/**
   * Manually Re-sequence a Route
   *
   * @see {@link https://route4me.io/docs/#manually-re-sequence-a-route}
   * @since 0.1.10
   *
   * @param {string}                 id     - Route ID
   * @param {Object<number, number>} order  - Resequence rules:
   *
   * * **keys**: ID of an address
   * * **values**: new sequence order of the address (counting from `1`)
   *
   * @param {module:route4me-node~RequestCallback<jsonschema:Routes.Route>} [callback]
   */

	}, {
		key: "resequence",
		value: function resequence(id, order, callback) {
			var qs = {
				"route_id": id
			};

			var addresses = Object.keys(order).map(function (addressId) {
				return {
					"route_destination_id": Number(addressId),
					"sequence_no": Number(order[addressId])
				};
			});

			var body = {
				addresses: addresses
			};

			debug("route resequence BODY: " + body);

			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/route.php",
				qs: qs,
				body: body,
				validationContext: "Routes.Route"
			}, callback);
		}

		/**
   * Optimize and re-sequence all destinations
   *
   * @see {@link https://route4me.io/docs/#manually-re-sequence-a-route}
   * @since 0.1.10
   *
   * @param {string} id       - Route ID
   * @param {string} criteria - Optimization type, possible values:
   * * `Distance` - optimize for distance
   * * `Time`
   * * `TimeWithTraffic`
   * * `NoneOptimize`
   * @param {module:route4me-node~RequestCallback} [callback]
   */

	}, {
		key: "optimize",
		value: function optimize(id, criteria, callback) {
			var qs = {
				"route_id": id,
				"disable_optimization": "0",
				"optimize": criteria
			};

			return this.r._makeRequest({
				method: "POST",
				path: "/api.v3/route/reoptimize_2.php",
				qs: qs,
				validationContext: utils.CustomInternalPostProcessing.fromJsonWithStatus
			}, callback);
		}
	}]);

	return Routes;
}();

module.exports = Routes;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var utils = __webpack_require__(0);

/**
 * Territories facility
 *
 * @category Territories
 */

var Territories = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#territories}
  * @since 0.1.8
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {Territories}                   - Territories facility
  */
	function Territories(requestManager) {
		_classCallCheck(this, Territories);

		this.r = requestManager;
	}

	/**
  * Create a new Territory.
  *
  * @see {@link https://route4me.io/docs/#create-a-territory}
  * @since 0.1.8
  *
  * @param {jsonschema:Territories.Territory}  data       - Valid Territory data.
  * @param {module:route4me-node~RequestCallback<jsonschema:Territories.Territory>}
  *        [callback]
  */


	_createClass(Territories, [{
		key: "create",
		value: function create(data, callback) {
			return this.r._makeRequest({
				method: "POST",
				path: "/api.v4/territory.php",
				body: data,
				validationContext: "Territories.Territory"
			}, callback);
		}

		/**
   * Get a specified Territory by ID.
   *
   * @see {@link https://route4me.io/docs/#get-a-territory}
   * @since 0.1.8
   *
   * @param {string}   id        - Territory ID
   * @param {Object}   [options] - Additional options for `get`
   * @param {boolean}  [options.includeAddresses=false] - If true, enclosed
   * addresses will be included in a response
   * @param {module:route4me-node~RequestCallback<jsonschema:Territories.Territory>} [callback]
   */

	}, {
		key: "get",
		value: function get(id, options, callback) {
			var cb = callback;
			var opt = options;
			if ("undefined" === typeof cb && "function" === typeof opt) {
				cb = opt;
				opt = {};
			}

			opt = opt || {};

			var includeAddresses = false;
			if (undefined !== opt.includeAddresses) {
				includeAddresses = !!opt.includeAddresses;
			}

			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/territory.php",
				qs: {
					"territory_id": id,
					"addresses": includeAddresses ? "1" : "0"
				},
				validationContext: "Territories.Territory"
			}, cb);
		}

		/**
   * GET all of the Territories defined by a user.
   *
   * @see {@link https://route4me.io/docs/#get-multiple-territories}
   * @since 0.1.8
   *
   * @todo TODO: There is no schema for the response, but it is just an array of known schema
   *
   * @param {module:route4me-node~RequestCallback<jsonschema:Territories.Territories>} [callback]
   */

	}, {
		key: "list",
		value: function list(callback) {
			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/territory.php",
				validationContext: "Territories.Territories"
			}, callback);
		}

		/**
   * UPDATE a specified Territory.
   *
   * @see {@link https://route4me.io/docs/#update-a-territory}
   * @since 0.1.8
   *
   * @param {string}  id       - Territory ID
   * @param {jsonschema:Territories.Territory}  data       - Valid Territory data.
   * @param {module:route4me-node~RequestCallback<jsonschema:Territories.Territory>}
   *        [callback]
   */

	}, {
		key: "update",
		value: function update(id, data, callback) {
			return this.r._makeRequest({
				method: "PUT",
				path: "/api.v4/territory.php",
				qs: {
					"territory_id": id
				},
				body: data,
				validationContext: "Territories.Territory"
			}, callback);
		}

		/**
   * DELETE a specified Territory.
   *
   * @see {@link https://route4me.io/docs/#remove-a-territory}
   * @since 0.1.8
   *
   * @param {string}  id       - Territory ID
   * @param {module:route4me-node~RequestCallback<boolean>}
   *     [callback]
   */

	}, {
		key: "remove",
		value: function remove(id, callback) {
			return this.r._makeRequest({
				method: "DELETE",
				path: "/api.v4/territory.php",
				qs: {
					"territory_id": id
				},
				validationContext: utils.CustomInternalPostProcessing.fromJsonWithStatus
			}, callback);
		}
	}]);

	return Territories;
}();

module.exports = Territories;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = __webpack_require__(2)("route4me");

var utils = __webpack_require__(0);
var errors = __webpack_require__(1);

function _createRouteTrackingValidate(data, ctx, res) {
	if (!data || "boolean" !== typeof data.status) {
		return new errors.Route4MeValidationError("Invalid response", data);
	}

	if (true === data.status) {
		return true;
	}

	// TODO: parse real error
	return new errors.Route4MeApiError("Failed", res);
}

/**
 * Tracking facility
 *
 * @category Tracking
 */

var Tracking = function () {
	/**
  * Constructor
  *
  * @see {@link https://route4me.io/docs/#tracking}
  * @since 0.1.8
  * @private
  *
  * @param  {RequestManager} requestManager - Request Manager
  * @return {Tracking}                      - Tracking facility
  */
	function Tracking(requestManager) {
		_classCallCheck(this, Tracking);

		this.r = requestManager;
	}

	/**
  * Get Asset Tracking Data
  *
  * @see {@link https://route4me.io/docs/#get-asset-tracking-data}
  * @since 0.1.8
  *
  * @param {string}  tracking       - Tracking number
  * @param {module:route4me-node~RequestCallback<jsonschema:Tracking.AssetTracking>}
  *        [callback]
  */


	_createClass(Tracking, [{
		key: "getAssetTracking",
		value: function getAssetTracking(tracking, callback) {
			return this.r._makeRequest({
				method: "GET",
				path: "/api.v4/status.php",
				qs: {
					"tracking": tracking
				},
				validationContext: "Tracking.AssetTracking"
			}, callback);
		}

		/**
   * Get a device’s location history from a time range.
   *
   * **Be carefull:** custom dates are considered as in local timezone!
   *
   * @see {@link https://route4me.io/docs/#get-route-tracking-data}
   * @since 0.1.8
   *
   * @param {string}  routeId           - Route ID
   * @param {string|Object}  period     - Time period. Object with `from` and `trim` dates,
   * or one of predefined strings:
   * * `today`
   * * `yesterday`
   * * `thismonth`
   * * `7days`
   * * `14days`
   * * `30days`
   * * `60days`
   * * `90days`
   * * `all_time`
   * @param {string} [period.span="custom"] - One of predefined strings (this is an another
   * one way to determine it)
   * @param {Date}   period.from   - Custom start date
   * @param {Date}   period.trim   - Custom end date
   * @param {module:route4me-node~RequestCallback<jsonschema:Tracking.TrackingHistory>}
   *        [callback]
   */

	}, {
		key: "getRouteTrackingHistory",
		value: function getRouteTrackingHistory(routeId, period, callback) {
			var qs = {
				"route_id": routeId
			};

			if (utils.isObject(period)) {
				var span = period.span || "custom";

				if ("custom" === span) {
					var from = period.from || period.start || period.begin;
					var trim = period.trim || period.finish || period.end;
					qs["start_date"] = Math.floor(from.valueOf() / 1000);
					qs["end_date"] = Math.floor(trim.valueOf() / 1000);
				}
				qs["time_period"] = span;
			} else {
				qs["time_period"] = period.toString();
			}

			return this.r._makeRequest({
				method: "GET",
				path: "/get_device_location.php",
				qs: qs,
				validationContext: "Tracking.TrackingHistory"
			}, callback);
		}

		/**
   * Insert Route Tracking Data
   *
   * Set GPS position of a device.
   *
   * @see {@link https://route4me.io/docs/#insert-route-tracking-data}
   * @since 0.1.8
   *
   * @param {int}   trackingData - Route Tracking Data
   * @param {number}   trackingData.memberId - Member ID
   * @param {string}   trackingData.routeId - Route ID
   * @param {number}   trackingData.course - Movement course
   * @param {number}   trackingData.speed - Movement speed
   * @param {number}   trackingData.latitude - Latitude
   * @param {number}   trackingData.longitude - Longitude
   * @param {string}   trackingData.deviceType - Device type
   * @param {string}   trackingData.deviceGuid - Device GUID
   * @param {module:route4me-node~RequestCallback}
   * [callback]
   */

	}, {
		key: "createRouteTracking",
		value: function createRouteTracking(trackingData, callback) {
			var qs = { "frm": "JSON" };
			qs["member_id"] = trackingData.memberId || trackingData.member_id;
			qs["route_id"] = trackingData.routeId || trackingData.route_id;
			qs["course"] = trackingData.course;
			qs["speed"] = trackingData.speed;
			qs["lat"] = trackingData.latitude || trackingData.lat;
			qs["lng"] = trackingData.longitude || trackingData.lng;
			qs["device_type"] = trackingData.deviceType || trackingData.device_type;
			qs["device_guid"] = trackingData.deviceGuid || trackingData.device_guid;

			debug("createRouteTracking: parsed trackingData: " + qs);

			return this.r._makeRequest({
				method: "POST",
				path: "/track/set.php",
				qs: qs,
				validationContext: _createRouteTrackingValidate
			}, callback);
		}
	}]);

	return Tracking;
}();

module.exports = Tracking;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Vehicles facility
 *
 * @category Vehicles
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Vehicles = function () {
  /**
   * Constructor
   *
   * @see {@link https://route4me.io/docs/#vehicles}
   * @since 0.1.4
   * @private
   *
   * @param  {RequestManager} requestManager - Request Manager
   * @return {Vehicles}                      - Vehicles facility
   */
  function Vehicles(requestManager) {
    _classCallCheck(this, Vehicles);

    this.r = requestManager;
  }

  /**
   * Get vehicles that belong to the Route4Me account
   *
   * @todo Fix error in API docs: there the method utilizes `POST`-http-method to get results
   *
   * @see {@link https://route4me.io/docs/#get-vehicles}
   *
   * @param {module:route4me-node~RequestCallback<jsonschema:Vehicles.ResponseMany>} [callback]
   */


  _createClass(Vehicles, [{
    key: "list",
    value: function list(callback) {
      return this.r._makeRequest({
        method: "GET",
        path: "/api.v4/vehicle.php",
        validationContext: "Vehicles.ResponseMany"
      }, callback);
    }
  }]);

  return Vehicles;
}();

module.exports = Vehicles;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(23);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = {"version":"0.2.4"}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000
var m = s * 60
var h = m * 60
var d = h * 24
var y = d * 365.25

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {}
  var type = typeof val
  if (type === 'string' && val.length > 0) {
    return parse(val)
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ?
			fmtLong(val) :
			fmtShort(val)
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
}

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str)
  if (str.length > 10000) {
    return
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
  if (!match) {
    return
  }
  var n = parseFloat(match[1])
  var type = (match[2] || 'ms').toLowerCase()
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y
    case 'days':
    case 'day':
    case 'd':
      return n * d
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n
    default:
      return undefined
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd'
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h'
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm'
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's'
  }
  return ms + 'ms'
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms'
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name
  }
  return Math.ceil(ms / n) + ' ' + name + 's'
}


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Platform.js <https://mths.be/platform>
 * Copyright 2014-2016 Benjamin Tan <https://demoneaux.github.io/>
 * Copyright 2011-2013 John-David Dalton <http://allyoucanleet.com/>
 * Available under MIT license <https://mths.be/mit>
 */
;(function() {
  'use strict';

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used as a reference to the global object. */
  var root = (objectTypes[typeof window] && window) || this;

  /** Backup possible global object. */
  var oldRoot = root;

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */
  var maxSafeInteger = Math.pow(2, 53) - 1;

  /** Regular expression to detect Opera. */
  var reOpera = /\bOpera/;

  /** Possible global object. */
  var thisBinding = this;

  /** Used for native method references. */
  var objectProto = Object.prototype;

  /** Used to check for own properties of an object. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to resolve the internal `[[Class]]` of values. */
  var toString = objectProto.toString;

  /*--------------------------------------------------------------------------*/

  /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalize(string) {
    string = String(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */
  function cleanupOS(os, pattern, label) {
    // Platform tokens are defined at:
    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    var data = {
      '10.0': '10',
      '6.4':  '10 Technical Preview',
      '6.3':  '8.1',
      '6.2':  '8',
      '6.1':  'Server 2008 R2 / 7',
      '6.0':  'Server 2008 / Vista',
      '5.2':  'Server 2003 / XP 64-bit',
      '5.1':  'XP',
      '5.01': '2000 SP1',
      '5.0':  '2000',
      '4.0':  'NT',
      '4.90': 'ME'
    };
    // Detect Windows version from platform tokens.
    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
        (data = data[/[\d.]+$/.exec(os)])) {
      os = 'Windows ' + data;
    }
    // Correct character case and cleanup string.
    os = String(os);

    if (pattern && label) {
      os = os.replace(RegExp(pattern, 'i'), label);
    }

    os = format(
      os.replace(/ ce$/i, ' CE')
        .replace(/\bhpw/i, 'web')
        .replace(/\bMacintosh\b/, 'Mac OS')
        .replace(/_PowerPC\b/i, ' OS')
        .replace(/\b(OS X) [^ \d]+/i, '$1')
        .replace(/\bMac (OS X)\b/, '$1')
        .replace(/\/(\d)/, ' $1')
        .replace(/_/g, '.')
        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
        .replace(/\bx86\.64\b/gi, 'x86_64')
        .replace(/\b(Windows Phone) OS\b/, '$1')
        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
        .split(' on ')[0]
    );

    return os;
  }

  /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */
  function each(object, callback) {
    var index = -1,
        length = object ? object.length : 0;

    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
      while (++index < length) {
        callback(object[index], index, object);
      }
    } else {
      forOwn(object, callback);
    }
  }

  /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */
  function format(string) {
    string = trim(string);
    return /^(?:webOS|i(?:OS|P))/.test(string)
      ? string
      : capitalize(string);
  }

  /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */
  function forOwn(object, callback) {
    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        callback(object[key], key, object);
      }
    }
  }

  /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */
  function getClassOf(value) {
    return value == null
      ? capitalize(value)
      : toString.call(value).slice(8, -1);
  }

  /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */
  function isHostType(object, property) {
    var type = object != null ? typeof object[property] : 'number';
    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
      (type == 'object' ? !!object[property] : true);
  }

  /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */
  function qualify(string) {
    return String(string).replace(/([ -])(?!$)/g, '$1?');
  }

  /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */
  function reduce(array, callback) {
    var accumulator = null;
    each(array, function(value, index) {
      accumulator = callback(accumulator, value, index, array);
    });
    return accumulator;
  }

  /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */
  function trim(string) {
    return String(string).replace(/^ +| +$/g, '');
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */
  function parse(ua) {

    /** The environment context object. */
    var context = root;

    /** Used to flag when a custom context is provided. */
    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';

    // Juggle arguments.
    if (isCustomContext) {
      context = ua;
      ua = null;
    }

    /** Browser navigator object. */
    var nav = context.navigator || {};

    /** Browser user agent string. */
    var userAgent = nav.userAgent || '';

    ua || (ua = userAgent);

    /** Used to flag when `thisBinding` is the [ModuleScope]. */
    var isModuleScope = isCustomContext || thisBinding == oldRoot;

    /** Used to detect if browser is like Chrome. */
    var likeChrome = isCustomContext
      ? !!nav.likeChrome
      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

    /** Internal `[[Class]]` value shortcuts. */
    var objectClass = 'Object',
        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
        enviroClass = isCustomContext ? objectClass : 'Environment',
        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

    /** Detect Java environments. */
    var java = /\bJava/.test(javaClass) && context.java;

    /** Detect Rhino. */
    var rhino = java && getClassOf(context.environment) == enviroClass;

    /** A character to represent alpha. */
    var alpha = java ? 'a' : '\u03b1';

    /** A character to represent beta. */
    var beta = java ? 'b' : '\u03b2';

    /** Browser document object. */
    var doc = context.document || {};

    /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */
    var opera = context.operamini || context.opera;

    /** Opera `[[Class]]`. */
    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
      ? operaClass
      : (opera = null);

    /*------------------------------------------------------------------------*/

    /** Temporary variable used over the script's lifetime. */
    var data;

    /** The CPU architecture. */
    var arch = ua;

    /** Platform description array. */
    var description = [];

    /** Platform alpha/beta indicator. */
    var prerelease = null;

    /** A flag to indicate that environment features should be used to resolve the platform. */
    var useFeatures = ua == userAgent;

    /** The browser/environment version. */
    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

    /** A flag to indicate if the OS ends with "/ Version" */
    var isSpecialCasedOS;

    /* Detectable layout engines (order is important). */
    var layout = getLayout([
      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
      'Trident',
      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
      'iCab',
      'Presto',
      'NetFront',
      'Tasman',
      'KHTML',
      'Gecko'
    ]);

    /* Detectable browser names (order is important). */
    var name = getName([
      'Adobe AIR',
      'Arora',
      'Avant Browser',
      'Breach',
      'Camino',
      'Epiphany',
      'Fennec',
      'Flock',
      'Galeon',
      'GreenBrowser',
      'iCab',
      'Iceweasel',
      'K-Meleon',
      'Konqueror',
      'Lunascape',
      'Maxthon',
      { 'label': 'Microsoft Edge', 'pattern': 'Edge' },
      'Midori',
      'Nook Browser',
      'PaleMoon',
      'PhantomJS',
      'Raven',
      'Rekonq',
      'RockMelt',
      'SeaMonkey',
      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Sleipnir',
      'SlimBrowser',
      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
      'Sunrise',
      'Swiftfox',
      'WebPositive',
      'Opera Mini',
      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
      'Opera',
      { 'label': 'Opera', 'pattern': 'OPR' },
      'Chrome',
      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
      { 'label': 'IE', 'pattern': 'IEMobile' },
      { 'label': 'IE', 'pattern': 'MSIE' },
      'Safari'
    ]);

    /* Detectable products (order is important). */
    var product = getProduct([
      { 'label': 'BlackBerry', 'pattern': 'BB10' },
      'BlackBerry',
      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
      'Google TV',
      'Lumia',
      'iPad',
      'iPod',
      'iPhone',
      'Kindle',
      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Nexus',
      'Nook',
      'PlayBook',
      'PlayStation 3',
      'PlayStation 4',
      'PlayStation Vita',
      'TouchPad',
      'Transformer',
      { 'label': 'Wii U', 'pattern': 'WiiU' },
      'Wii',
      'Xbox One',
      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
      'Xoom'
    ]);

    /* Detectable manufacturers. */
    var manufacturer = getManufacturer({
      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
      'Archos': {},
      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
      'Asus': { 'Transformer': 1 },
      'Barnes & Noble': { 'Nook': 1 },
      'BlackBerry': { 'PlayBook': 1 },
      'Google': { 'Google TV': 1, 'Nexus': 1 },
      'HP': { 'TouchPad': 1 },
      'HTC': {},
      'LG': {},
      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
      'Motorola': { 'Xoom': 1 },
      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
      'Nokia': { 'Lumia': 1 },
      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
      'Sony': { 'PlayStation 4': 1, 'PlayStation 3': 1, 'PlayStation Vita': 1 }
    });

    /* Detectable operating systems (order is important). */
    var os = getOS([
      'Windows Phone',
      'Android',
      'CentOS',
      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
      'Debian',
      'Fedora',
      'FreeBSD',
      'Gentoo',
      'Haiku',
      'Kubuntu',
      'Linux Mint',
      'OpenBSD',
      'Red Hat',
      'SuSE',
      'Ubuntu',
      'Xubuntu',
      'Cygwin',
      'Symbian OS',
      'hpwOS',
      'webOS ',
      'webOS',
      'Tablet OS',
      'Linux',
      'Mac OS X',
      'Macintosh',
      'Mac',
      'Windows 98;',
      'Windows '
    ]);

    /*------------------------------------------------------------------------*/

    /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */
    function getLayout(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */
    function getManufacturer(guesses) {
      return reduce(guesses, function(result, value, key) {
        // Lookup the manufacturer by product or scan the UA for the manufacturer.
        return result || (
          value[product] ||
          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
        ) && key;
      });
    }

    /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */
    function getName(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */
    function getOS(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
            )) {
          result = cleanupOS(result, pattern, guess.label || guess);
        }
        return result;
      });
    }

    /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */
    function getProduct(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
            )) {
          // Split by forward slash and append product version if needed.
          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
            result[0] += ' ' + result[1];
          }
          // Correct character case and cleanup string.
          guess = guess.label || guess;
          result = format(result[0]
            .replace(RegExp(pattern, 'i'), guess)
            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
        }
        return result;
      });
    }

    /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */
    function getVersion(patterns) {
      return reduce(patterns, function(result, pattern) {
        return result || (RegExp(pattern +
          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
      });
    }

    /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */
    function toStringPlatform() {
      return this.description || '';
    }

    /*------------------------------------------------------------------------*/

    // Convert layout to an array so we can add extra details.
    layout && (layout = [layout]);

    // Detect product names that contain their manufacturer's name.
    if (manufacturer && !product) {
      product = getProduct([manufacturer]);
    }
    // Clean up Google TV.
    if ((data = /\bGoogle TV\b/.exec(product))) {
      product = data[0];
    }
    // Detect simulators.
    if (/\bSimulator\b/i.test(ua)) {
      product = (product ? product + ' ' : '') + 'Simulator';
    }
    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
      description.push('running in Turbo/Uncompressed mode');
    }
    // Detect IE Mobile 11.
    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
      data = parse(ua.replace(/like iPhone OS/, ''));
      manufacturer = data.manufacturer;
      product = data.product;
    }
    // Detect iOS.
    else if (/^iP/.test(product)) {
      name || (name = 'Safari');
      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
        ? ' ' + data[1].replace(/_/g, '.')
        : '');
    }
    // Detect Kubuntu.
    else if (name == 'Konqueror' && !/buntu/i.test(os)) {
      os = 'Kubuntu';
    }
    // Detect Android browsers.
    else if ((manufacturer && manufacturer != 'Google' &&
        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
      name = 'Android Browser';
      os = /\bAndroid\b/.test(os) ? os : 'Android';
    }
    // Detect Silk desktop/accelerated modes.
    else if (name == 'Silk') {
      if (!/\bMobi/i.test(ua)) {
        os = 'Android';
        description.unshift('desktop mode');
      }
      if (/Accelerated *= *true/i.test(ua)) {
        description.unshift('accelerated');
      }
    }
    // Detect PaleMoon identifying as Firefox.
    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
      description.push('identifying as Firefox ' + data[1]);
    }
    // Detect Firefox OS and products running Firefox.
    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
      os || (os = 'Firefox OS');
      product || (product = data[1]);
    }
    // Detect false positives for Firefox/Safari.
    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
      // Escape the `/` for Firefox 1.
      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
        // Clear name of false positives.
        name = null;
      }
      // Reassign a generic name.
      if ((data = product || manufacturer || os) &&
          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
      }
    }
    // Detect non-Opera (Presto-based) versions (order is important).
    if (!version) {
      version = getVersion([
        '(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|Silk(?!/[\\d.]+$))',
        'Version',
        qualify(name),
        '(?:Firefox|Minefield|NetFront)'
      ]);
    }
    // Detect stubborn layout engines.
    if ((data =
          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
        )) {
      layout = [data];
    }
    // Detect Windows Phone 7 desktop mode.
    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
      name += ' Mobile';
      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
      description.unshift('desktop mode');
    }
    // Detect Windows Phone 8.x desktop mode.
    else if (/\bWPDesktop\b/i.test(ua)) {
      name = 'IE Mobile';
      os = 'Windows Phone 8.x';
      description.unshift('desktop mode');
      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
    }
    // Detect IE 11.
    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
      if (name) {
        description.push('identifying as ' + name + (version ? ' ' + version : ''));
      }
      name = 'IE';
      version = data[1];
    }
    // Leverage environment features.
    if (useFeatures) {
      // Detect server-side environments.
      // Rhino has a global function while others have a global object.
      if (isHostType(context, 'global')) {
        if (java) {
          data = java.lang.System;
          arch = data.getProperty('os.arch');
          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
        }
        if (isModuleScope && isHostType(context, 'system') && (data = [context.system])[0]) {
          os || (os = data[0].os || null);
          try {
            data[1] = context.require('ringo/engine').version;
            version = data[1].join('.');
            name = 'RingoJS';
          } catch(e) {
            if (data[0].global.system == context.system) {
              name = 'Narwhal';
            }
          }
        }
        else if (
          typeof context.process == 'object' && !context.process.browser &&
          (data = context.process)
        ) {
          name = 'Node.js';
          arch = data.arch;
          os = data.platform;
          version = /[\d.]+/.exec(data.version)[0];
        }
        else if (rhino) {
          name = 'Rhino';
        }
      }
      // Detect Adobe AIR.
      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
        name = 'Adobe AIR';
        os = data.flash.system.Capabilities.os;
      }
      // Detect PhantomJS.
      else if (getClassOf((data = context.phantom)) == phantomClass) {
        name = 'PhantomJS';
        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
      }
      // Detect IE compatibility modes.
      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
        // We're in compatibility mode when the Trident version + 4 doesn't
        // equal the document mode.
        version = [version, doc.documentMode];
        if ((data = +data[1] + 4) != version[1]) {
          description.push('IE ' + version[1] + ' mode');
          layout && (layout[1] = '');
          version[1] = data;
        }
        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
      }
      os = os && format(os);
    }
    // Detect prerelease phases.
    if (version && (data =
          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
          /\bMinefield\b/i.test(ua) && 'a'
        )) {
      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
      version = version.replace(RegExp(data + '\\+?$'), '') +
        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
    }
    // Detect Firefox Mobile.
    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS)\b/.test(os)) {
      name = 'Firefox Mobile';
    }
    // Obscure Maxthon's unreliable version.
    else if (name == 'Maxthon' && version) {
      version = version.replace(/\.[\d.]+/, '.x');
    }
    // Detect Xbox 360 and Xbox One.
    else if (/\bXbox\b/i.test(product)) {
      os = null;
      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
        description.unshift('mobile mode');
      }
    }
    // Add mobile postfix.
    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
        (os == 'Windows CE' || /Mobi/i.test(ua))) {
      name += ' Mobile';
    }
    // Detect IE platform preview.
    else if (name == 'IE' && useFeatures && context.external === null) {
      description.unshift('platform preview');
    }
    // Detect BlackBerry OS version.
    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
          version
        )) {
      data = [data, /BB10/.test(ua)];
      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
      version = null;
    }
    // Detect Opera identifying/masking itself as another browser.
    // http://www.opera.com/support/kb/view/843/
    else if (this != forOwn && product != 'Wii' && (
          (useFeatures && opera) ||
          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
          (name == 'IE' && (
            (os && !/^Win/.test(os) && version > 5.5) ||
            /\bWindows XP\b/.test(os) && version > 8 ||
            version == 8 && !/\bTrident\b/.test(ua)
          ))
        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
      // When "identifying", the UA contains both Opera and the other browser's name.
      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
      if (reOpera.test(name)) {
        if (/\bIE\b/.test(data) && os == 'Mac OS') {
          os = null;
        }
        data = 'identify' + data;
      }
      // When "masking", the UA contains only the other browser's name.
      else {
        data = 'mask' + data;
        if (operaClass) {
          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
        } else {
          name = 'Opera';
        }
        if (/\bIE\b/.test(data)) {
          os = null;
        }
        if (!useFeatures) {
          version = null;
        }
      }
      layout = ['Presto'];
      description.push(data);
    }
    // Detect WebKit Nightly and approximate Chrome/Safari versions.
    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
      // Correct build number for numeric comparison.
      // (e.g. "532.5" becomes "532.05")
      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
      // Nightly builds are postfixed with a "+".
      if (name == 'Safari' && data[1].slice(-1) == '+') {
        name = 'WebKit Nightly';
        prerelease = 'alpha';
        version = data[1].slice(0, -1);
      }
      // Clear incorrect browser versions.
      else if (version == data[1] ||
          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
        version = null;
      }
      // Use the full Chrome version when available.
      data[1] = (/\bChrome\/([\d.]+)/i.exec(ua) || 0)[1];
      // Detect Blink layout engine.
      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
        layout = ['Blink'];
      }
      // Detect JavaScriptCore.
      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
      if (!useFeatures || (!likeChrome && !data[1])) {
        layout && (layout[1] = 'like Safari');
        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : '8');
      } else {
        layout && (layout[1] = 'like Chrome');
        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
      }
      // Add the postfix of ".x" or "+" for approximate versions.
      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
      // Obscure version for some Safari 1-2 releases.
      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
        version = data;
      }
    }
    // Detect Opera desktop modes.
    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
      name += ' ';
      description.unshift('desktop mode');
      if (data == 'zvav') {
        name += 'Mini';
        version = null;
      } else {
        name += 'Mobile';
      }
      os = os.replace(RegExp(' *' + data + '$'), '');
    }
    // Detect Chrome desktop mode.
    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
      description.unshift('desktop mode');
      name = 'Chrome Mobile';
      version = null;

      if (/\bOS X\b/.test(os)) {
        manufacturer = 'Apple';
        os = 'iOS 4.3+';
      } else {
        os = null;
      }
    }
    // Strip incorrect OS versions.
    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
        ua.indexOf('/' + data + '-') > -1) {
      os = trim(os.replace(data, ''));
    }
    // Add layout engine.
    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
        /Browser|Lunascape|Maxthon/.test(name) ||
        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Sleipnir|Web)/.test(name) && layout[1])) {
      // Don't add layout details to description if they are falsey.
      (data = layout[layout.length - 1]) && description.push(data);
    }
    // Combine contextual information.
    if (description.length) {
      description = ['(' + description.join('; ') + ')'];
    }
    // Append manufacturer to description.
    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
      description.push('on ' + manufacturer);
    }
    // Append product to description.
    if (product) {
      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
    }
    // Parse the OS into an object.
    if (os) {
      data = / ([\d.+]+)$/.exec(os);
      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
      os = {
        'architecture': 32,
        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
        'version': data ? data[1] : null,
        'toString': function() {
          var version = this.version;
          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
        }
      };
    }
    // Add browser/OS architecture.
    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
      if (os) {
        os.architecture = 64;
        os.family = os.family.replace(RegExp(' *' + data), '');
      }
      if (
          name && (/\bWOW64\b/i.test(ua) ||
          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
      ) {
        description.unshift('32-bit');
      }
    }
    // Chrome 39 and above on OS X is always 64-bit.
    else if (
        os && /^OS X/.test(os.family) &&
        name == 'Chrome' && parseFloat(version) >= 39
    ) {
      os.architecture = 64;
    }

    ua || (ua = null);

    /*------------------------------------------------------------------------*/

    /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */
    var platform = {};

    /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.description = ua;

    /**
     * The name of the browser's layout engine.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.layout = layout && layout[0];

    /**
     * The name of the product's manufacturer.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.manufacturer = manufacturer;

    /**
     * The name of the browser/environment.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.name = name;

    /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.prerelease = prerelease;

    /**
     * The name of the product hosting the browser.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.product = product;

    /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.ua = ua;

    /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.version = name && version;

    /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */
    platform.os = os || {

      /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */
      'architecture': null,

      /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE",
       * "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */
      'family': null,

      /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */
      'version': null,

      /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */
      'toString': function() { return 'null'; }
    };

    platform.parse = parse;
    platform.toString = toStringPlatform;

    if (platform.version) {
      description.unshift(version);
    }
    if (platform.name) {
      description.unshift(name);
    }
    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
      description.push(product ? '(' + os + ')' : 'on ' + os);
    }
    if (description.length) {
      platform.description = description.join(' ');
    }
    return platform;
  }

  /*--------------------------------------------------------------------------*/

  // Export platform.
  var platform = parse();

  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
  if (true) {
    // Expose platform on the global object to prevent errors when platform is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    root.platform = platform;

    // Define as an anonymous module so platform can be aliased through path mapping.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return platform;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for CommonJS support.
    forOwn(platform, function(value, key) {
      freeExports[key] = value;
    });
  }
  else {
    // Export to the global object.
    root.platform = platform;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module), __webpack_require__(32)))

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(20);
var RequestBase = __webpack_require__(28);
var isObject = __webpack_require__(3);
var isFunction = __webpack_require__(27);
var ResponseBase = __webpack_require__(29);
var shouldRetry = __webpack_require__(30);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only verison of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  return /[\/+]json\b/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
      status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str){
  var parse = request.parse[this.type];
  if(this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
        new_err.original = err;
        new_err.response = res;
        new_err.status = res.status;
      }
    } catch(e) {
      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can substitute for options
    options = pass;
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    }
  }

  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + btoa(user + ':' + pass));
    break;

    case 'auto':
      this.username = user;
      this.password = pass;
    break;
      
    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
    break;  
  }
  return this;
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  // console.log(this._retries, this._maxRetries)
  if (this._maxRetries && this._retries++ < this._maxRetries && shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */

Request.prototype._appendQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if (isFunction(this._sort)) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._appendQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  }
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn){
  var req = request('OPTIONS', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn){
  var req = request('DELETE', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Check if `fn` is a function.
 *
 * @param {Function} fn
 * @return {Boolean}
 * @api private
 */
var isObject = __webpack_require__(3);

function isFunction(fn) {
  var tag = isObject(fn) ? Object.prototype.toString.call(fn) : '';
  return tag === '[object Function]';
}

module.exports = isFunction;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(3);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, read, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  return this;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {
  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
      self.end(function(err, res){
        if (err) innerReject(err); else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
}

RequestBase.prototype.catch = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
}

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};


/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {

  // name should be either a string or an object.
  if (null === name ||  undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on){
  // This is browser-only functionality. Node side is no-op.
  if(on==undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function(){
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};


/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};


/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
}


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var utils = __webpack_require__(31);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field){
    return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
module.exports = function shouldRetry(err, res) {
  if (err && err.code && ~ERROR_CODES.indexOf(err.code)) return true;
  if (res && res.status && res.status >= 500) return true;
  // Superagent timeout
  if (err && 'timeout' in err && err.code == 'ECONNABORTED') return true;
  if (err && 'crossDomain' in err) return true;
  return false;
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, shouldStripCookie){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  if (shouldStripCookie) {
    delete header['cookie'];
  }
  return header;
};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// route4me.js